var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetintouch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-get-in-touch",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-get-in-touch:not(.animated) .animable {opacity: 0;}svg#freepik_stories-get-in-touch.animated #freepik--Floor--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Shadows--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Pictures--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Plants--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Table--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Device--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-get-in-touch.animated #freepik--Icons--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-get-in-touch.animated #freepik--Window--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-get-in-touch.animated #freepik--character-2--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-get-in-touch.animated #freepik--character-1--inject-5 {animation: 1s 1 forwards ease-in slideDown;animation-delay: 0s;}            @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5",
    className: "animable",
    style: {
      transformOrigin: "251.72px 350.29px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-5",
    cx: 251.72,
    cy: 350.29,
    rx: 235.28,
    ry: 124.1,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "251.72px 350.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5",
    className: "animable",
    style: {
      transformOrigin: "263.702px 363.431px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M400.74,309.58c-16.3,9.41-16.3,24.66,0,34.07s42.71,9.41,59,0,16.29-24.66,0-34.07S417,300.17,400.74,309.58Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "430.236px 326.615px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 366.08,
    cy: 381.84,
    rx: 64.58,
    ry: 37.28,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "366.08px 381.84px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M57,411.58l6.6,3.81a8.35,8.35,0,0,0,7.54,0l145.52-84c2.08-1.2,2.08-3.15,0-4.35l-6.61-3.81a8.26,8.26,0,0,0-7.53,0L57,407.23C54.93,408.43,54.93,410.38,57,411.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.834px 369.306px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M94,419.63l6.6,3.81a8.35,8.35,0,0,0,7.54,0L232.33,352c2.08-1.2,2.08-3.15,0-4.35l-6.6-3.82a8.35,8.35,0,0,0-7.54,0L94,415.28C91.94,416.48,91.94,418.43,94,419.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.173px 383.635px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.715px 111.09px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.715px 82.655px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.715px 82.655px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "454.46 111.28 452.71 112.32 416.95 91.68 418.69 90.64 454.46 111.28",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "435.705px 101.48px"
    },
    id: "eljl6dce7ejws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.69 90.64 452.71 110.27 452.71 74.65 418.69 55.02 418.69 90.64",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.7px 82.645px"
    },
    id: "elq45tuca9rzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.66,93.57,456,118V72.75L413.66,48.31ZM417,54l35.76,20.65v37.67L417,91.68Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "434.83px 83.155px"
    },
    id: "eletfgeew0ag7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.95 91.68 418.69 90.64 418.69 55.02 416.95 54 416.95 91.68",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.82px 72.84px"
    },
    id: "el920b1rb6ek8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.66 48.3 415.43 47.29 457.77 71.74 456 72.75 413.66 48.3",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "435.715px 60.02px"
    },
    id: "el3plz54g7u68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.77 71.74 456 72.75 456 118.02 457.77 117.01 457.77 71.74",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.885px 94.88px"
    },
    id: "eljq0alu0wjx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.705px 88.575px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "420.02 89.57 451.39 107.68 451.39 98.63 443.54 80.52 438.66 85.05 440.42 92.64 429.59 69.47 420.02 80.52 420.02 89.57",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "435.705px 88.575px"
    },
    id: "elrm97so9pdz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,71.78a5.07,5.07,0,0,1,2.32,4c0,1.48-1,2.08-2.32,1.34a5.12,5.12,0,0,1-2.31-4C436.64,71.64,437.67,71,439,71.78Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "439.004px 74.4412px"
    },
    id: "eli7hqwr5hilg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.715px 139.525px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.715px 139.525px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "454.46 168.16 452.71 169.2 416.95 148.55 418.69 147.51 454.46 168.16",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "435.705px 158.355px"
    },
    id: "elpg66kzvt8rj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.69 147.51 452.71 167.15 452.71 131.52 418.69 111.9 418.69 147.51",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.7px 139.525px"
    },
    id: "elo9og78tbvpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.66,150.45,456,174.89V129.62l-42.34-24.44ZM417,110.87l35.76,20.65V169.2L417,148.55Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "434.83px 140.035px"
    },
    id: "elxs5j2ftq51f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.95 148.55 418.69 147.51 418.69 111.9 416.95 110.87 416.95 148.55",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.82px 129.71px"
    },
    id: "el61vsz9zzt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.66 105.18 415.43 104.16 457.77 128.61 456 129.62 413.66 105.18",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "435.715px 116.89px"
    },
    id: "el5lt16m9rdkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.77 128.61 456 129.62 456 174.89 457.77 173.88 457.77 128.61",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.885px 151.75px"
    },
    id: "elasbzvyvsyc9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-5",
    className: "animable",
    style: {
      transformOrigin: "435.705px 145.45px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "420.02 146.44 451.39 164.55 451.39 155.5 443.54 137.39 438.66 141.92 440.42 149.51 429.59 126.35 420.02 137.39 420.02 146.44",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "435.705px 145.45px"
    },
    id: "eln6jtg55jdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,128.65a5.1,5.1,0,0,1,2.32,4c0,1.48-1,2.08-2.32,1.34a5.11,5.11,0,0,1-2.31-4C436.64,128.51,437.67,127.91,439,128.65Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "439.004px 131.32px"
    },
    id: "elcps8p1k87mp",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5",
    className: "animable",
    style: {
      transformOrigin: "48.4203px 359.772px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5",
    className: "animable",
    style: {
      transformOrigin: "48.4203px 359.772px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6,400.74c2.47-13.73,3.63-28.95-1-50.35-3.88-18-13.64-33.45-24.88-35.49-4.56-.83-9.24,1.82-10.4,4.6-3.18,7.65,2.66,14.62,5.38,18.1,2,2.6,20.87,21.08,22.45,49.2l.94,16.82c.14.87.9,1.31,1.5.87Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "49.0799px 359.704px"
    },
    id: "elhlksf5lso24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele6t9blskq97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6,400.74c2.47-13.73,3.63-28.95-1-50.35-3.88-18-13.64-33.45-24.88-35.49-4.56-.83-9.24,1.82-10.4,4.6-3.18,7.65,2.66,14.62,5.38,18.1,2,2.6,20.87,21.08,22.45,49.2l.94,16.82c.14.87.9,1.31,1.5.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "49.0799px 359.704px"
    },
    className: "animable",
    id: "elgsv8fw933zd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.51,394.42a.66.66,0,0,1-.35-.64c.67-35.82-9.84-58.21-25-70.87A.76.76,0,0,1,38,322a.43.43,0,0,1,.69-.19c15.37,12.81,26.16,35.7,25.47,72a.58.58,0,0,1-.51.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "51.0528px 358.077px"
    },
    id: "eltpiria1xh1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.59,404.49c-1.68,1.19-2.6-1.26-3.44-4.07-2.69-9.06-5.65-13.84-10.7-20.2-6.23-7.83-17-15.06-18.22-21.54-1.08-5.88,3.65-10.41,12.07-7.27,10.11,3.78,23.77,16,23.31,51.19Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "45.8495px 377.591px"
    },
    id: "elipjirwzadvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.31,400a.64.64,0,0,1-.4-.51c-4.77-27.15-19.84-40.62-26.81-43.29a.72.72,0,0,1-.37-.81c.07-.34.33-.54.61-.43,7.72,2.94,22.68,16.58,27.56,44.3a.63.63,0,0,1-.38.75A.3.3,0,0,1,61.31,400Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "47.8155px 377.477px"
    },
    id: "elctym2ltdpzi",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5",
    className: "animable",
    style: {
      transformOrigin: "430.072px 284.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-5",
    className: "animable",
    style: {
      transformOrigin: "430.072px 284.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-5",
    className: "animable",
    style: {
      transformOrigin: "430.072px 290.996px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.45,280.62a1.07,1.07,0,0,1,.63-.87,3.35,3.35,0,0,1,3,0,1.07,1.07,0,0,1,.62.87l-7.6,44.87h0a.76.76,0,0,1-.44.6,2.35,2.35,0,0,1-2.13,0,.74.74,0,0,1-.44-.6h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.395px 302.87px"
    },
    id: "el1rdm083np74j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.06,280.62a1.07,1.07,0,0,0-.63-.87,3.33,3.33,0,0,0-3,0,1.07,1.07,0,0,0-.63.87l7.6,44.87h0a.76.76,0,0,0,.44.6,2.37,2.37,0,0,0,2.14,0,.78.78,0,0,0,.44-.6h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "460.11px 302.869px"
    },
    id: "elzradsqtqap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.15,284a1.07,1.07,0,0,0-.63-.87,3.33,3.33,0,0,0-3,0,1.07,1.07,0,0,0-.63.87l.63,53.38h0a.76.76,0,0,0,.44.6,2.35,2.35,0,0,0,2.13,0,.74.74,0,0,0,.44-.6h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "430.02px 310.504px"
    },
    id: "eldc974yax9ke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.27,265.84h0c0-5.65-3.7-11.3-11.17-15.61-14.93-8.63-39.16-8.63-54.09,0-7.47,4.31-11.18,10-11.17,15.61h0v3h0c.09,5.58,3.83,11.14,11.21,15.4,14.94,8.62,39.16,8.62,54.09,0,7.38-4.26,11.12-9.82,11.21-15.4h0Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "430.095px 267.231px"
    },
    id: "elgx0s6z5qn64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo78qtu29vkj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.27,265.84h0c0-5.65-3.7-11.3-11.17-15.61-14.93-8.63-39.16-8.63-54.09,0-7.47,4.31-11.18,10-11.17,15.61h0v3h0c.09,5.58,3.83,11.14,11.21,15.4,14.94,8.62,39.16,8.62,54.09,0,7.38-4.26,11.12-9.82,11.21-15.4h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "430.095px 267.231px"
    },
    className: "animable",
    id: "el3871uxrzz1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403,250.23c-14.94,8.62-14.94,22.61,0,31.23s39.16,8.63,54.09,0,14.94-22.61,0-31.23S417.9,241.6,403,250.23Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "430.043px 265.845px"
    },
    id: "el9d3j2adibmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbawu56w406v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403,250.23c-14.94,8.62-14.94,22.61,0,31.23s39.16,8.63,54.09,0,14.94-22.61,0-31.23S417.9,241.6,403,250.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "430.043px 265.845px"
    },
    className: "animable",
    id: "elwdyufn6v5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5",
    className: "animable",
    style: {
      transformOrigin: "429.924px 250.789px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elowids6vdni"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05,
      transformOrigin: "429.773px 263.55px"
    },
    className: "animable",
    id: "elgoekqex7w3w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.4,258.55c4.76,2.75,4.76,7.21,0,10s-12.49,2.75-17.25,0-4.77-7.21,0-10S433.63,255.8,438.4,258.55Z",
    id: "elqbogx5gmu1",
    className: "animable",
    style: {
      transformOrigin: "429.773px 263.55px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M422.18,264.14c-4.15-4.23-6.59-14.81-2.54-18.16h20.59c4,3.35,1.61,13.92-2.53,18.16l-.12.11a.93.93,0,0,1-.14.14l-.37.34-.1.08-.32.23a4.41,4.41,0,0,1-.53.35,13.68,13.68,0,0,1-12.37,0h0c-.18-.11-.36-.22-.54-.35l-.29-.22-.12-.1a3.73,3.73,0,0,1-.36-.32l-.17-.16Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "429.924px 256.424px"
    },
    id: "elfjxa4wjxz5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.44,244.62c4.7,2.72,4.7,7.12,0,9.83s-12.31,2.71-17,0-4.7-7.11,0-9.83S433.75,241.91,438.44,244.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "429.942px 249.533px"
    },
    id: "elielom282yy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.11,246.55c2.86,1.65,2.86,4.32,0,6a11.44,11.44,0,0,1-10.35,0c-2.86-1.65-2.86-4.32,0-6A11.44,11.44,0,0,1,435.11,246.55Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "429.935px 249.55px"
    },
    id: "el8spq45qfjfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.76,249.38a11.44,11.44,0,0,1,10.35,0,4.7,4.7,0,0,1,1.71,1.57,4.54,4.54,0,0,1-1.71,1.57,11.44,11.44,0,0,1-10.35,0,4.54,4.54,0,0,1-1.71-1.57A4.7,4.7,0,0,1,424.76,249.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.935px 250.95px"
    },
    id: "elzvhnv05typ",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.48,251a23.48,23.48,0,0,0,3.75-5c1.73-3.06,2-7.16,1.15-7.66s-4.53,3.58-4.53,3.58a22.45,22.45,0,0,0,.38-5.22c-.15-2.73-.82-5.2-1.6-5.7s-2.52,2.94-3.27,5.43-1.19,4.53-1.19,4.53a39.33,39.33,0,0,0-1.35-5.73c-.9-2.58-1.73-3.17-2.37-2.91s-1.06,1.46-1.24,4.9a34.61,34.61,0,0,0,.15,4.93s-1.28-1.41-2.71-2.78-2.23-1.71-2.68-1.42-.57,2.62,1.86,7a24.2,24.2,0,0,0,4.57,6S428.75,253.12,434.48,251Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "429.279px 241.44px"
    },
    id: "elb8inen8w20u",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5",
    className: "animable",
    style: {
      transformOrigin: "129.42px 219.41px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-5",
    className: "animable",
    style: {
      transformOrigin: "129.42px 219.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.56,31.76,62.36,102.32a12.32,12.32,0,0,0-6.15,10.2V396.64c0,4.18,2.58,9.06,5.76,10.9s8.7,1.63,12.32-.46l121.78-70.31a14.55,14.55,0,0,0,6.55-11.35V42.19c0-4.18-2.58-9-5.76-10.89S188.17,29.67,184.56,31.76Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "129.415px 219.41px"
    },
    id: "el3ximskvzm64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1r4xcvz0edj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.56,31.76,62.36,102.32a12.32,12.32,0,0,0-6.15,10.2V396.64c0,4.18,2.58,9.06,5.76,10.9s8.7,1.63,12.32-.46l121.78-70.31a14.55,14.55,0,0,0,6.55-11.35V42.19c0-4.18-2.58-9-5.76-10.89S188.17,29.67,184.56,31.76Z",
    style: {
      opacity: 0.05,
      transformOrigin: "129.415px 219.41px"
    },
    className: "animable",
    id: "el6jkqp3av6ha"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,407.83c-3.5,1.36-8,1.29-10.74-.29-3.18-1.84-5.76-6.72-5.76-10.9V112.52a11.76,11.76,0,0,1,1.66-5.62l10.57,6a12.76,12.76,0,0,0-3,7.63V402C65.39,407,68.57,409.37,72.72,407.83Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "64.47px 257.846px"
    },
    id: "elgczdt72ipbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzrtjqyw5dlh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.72,407.83c-3.5,1.36-8,1.29-10.74-.29-3.18-1.84-5.76-6.72-5.76-10.9V112.52a11.76,11.76,0,0,1,1.66-5.62l10.57,6a12.76,12.76,0,0,0-3,7.63V402C65.39,407,68.57,409.37,72.72,407.83Z",
    style: {
      opacity: 0.3,
      transformOrigin: "64.47px 257.846px"
    },
    className: "animable",
    id: "elrdsia3xq0nc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.17,110.53a12.81,12.81,0,0,0-5.78,10V402c0,5.64,4,8,8.89,5.13l121.8-70.32a14.55,14.55,0,0,0,6.55-11.35V42.19c0-4.16-2.95-5.86-6.55-3.78Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "134.01px 222.938px"
    },
    id: "elnw6wsme4wee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr80l7yaq5ia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.17,110.53a12.81,12.81,0,0,0-5.78,10V402c0,5.64,4,8,8.89,5.13l121.8-70.32a14.55,14.55,0,0,0,6.55-11.35V42.19c0-4.16-2.95-5.86-6.55-3.78Z",
    style: {
      opacity: 0.15,
      transformOrigin: "134.01px 222.938px"
    },
    className: "animable",
    id: "el3h68cyqpy54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.66,127.46a13.77,13.77,0,0,0-6.23,10.79V390.87c0,4,2.79,5.58,6.23,3.59L190.72,328a13.82,13.82,0,0,0,6.22-10.79V64.62c0-4-2.8-5.57-6.23-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.185px 227.747px"
    },
    id: "el3mowvxj6nm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.42,310.33V62.93L75.66,127.46a13.78,13.78,0,0,0-6.23,10.79v247.4l111.76-64.54A13.79,13.79,0,0,0,187.42,310.33Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "128.425px 224.29px"
    },
    id: "elwdi9pcni61",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.71,88.18l19-10.94c1.13-.65,2.05-.19,2.05,1a4.38,4.38,0,0,1-2.05,3.4l-19,11c-1.13.65-2,.19-2-1A4.4,4.4,0,0,1,123.71,88.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.235px 84.94px"
    },
    id: "el51ukdw0vkap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,69.38c1.06-.62,1.92-.12,1.92,1.11a4.24,4.24,0,0,1-1.92,3.32c-1.06.61-1.92.12-1.92-1.11A4.24,4.24,0,0,1,156.23,69.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.23px 71.5928px"
    },
    id: "elsa5uabjif6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,64.94c1.06-.61,1.92-.11,1.92,1.11a4.24,4.24,0,0,1-1.92,3.33c-1.06.61-1.92.12-1.92-1.11A4.27,4.27,0,0,1,163.92,64.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.92px 67.1609px"
    },
    id: "el5jw65fepwdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.45,100.43c1.06-.61,1.92-.12,1.92,1.11a4.27,4.27,0,0,1-1.92,3.33c-1.06.61-1.92.11-1.92-1.11A4.24,4.24,0,0,1,102.45,100.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.45px 102.649px"
    },
    id: "elwd49hr5c4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.14,96c1.06-.62,1.92-.12,1.92,1.11a4.24,4.24,0,0,1-1.92,3.32c-1.06.62-1.92.12-1.92-1.11A4.24,4.24,0,0,1,110.14,96Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.14px 98.215px"
    },
    id: "elzmj9kc7n63",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-5",
    className: "animable",
    style: {
      transformOrigin: "292.175px 238.314px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-5",
    className: "animable",
    style: {
      transformOrigin: "337.27px 212.3px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-5",
    className: "animable",
    style: {
      transformOrigin: "337.27px 212.3px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.88,190.26a4.78,4.78,0,0,0-2.16-3.73l-1.75-1a4.79,4.79,0,0,0-4.3,0l-26.86,15.54a4.73,4.73,0,0,0-2.15,3.72v29.56a4.76,4.76,0,0,0,2.15,3.73l1.75,1a4.79,4.79,0,0,0,4.3,0l26.86-15.54a4.74,4.74,0,0,0,2.16-3.73Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "337.27px 212.305px"
    },
    id: "el4769kwi171h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmrbsoojw4oi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.66,234.34a4.76,4.76,0,0,0,2.15,3.73l1.75,1a4.8,4.8,0,0,0,3.93.17c-1,.38-1.78-.19-1.78-1.41V208.28a4.36,4.36,0,0,1,.63-2.12l-6-3.5a4.43,4.43,0,0,0-.63,2.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "322.575px 221.12px"
    },
    className: "animable",
    id: "els7j81s0s14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx4w6yeu3f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.8,189.65c-.25-.92-1.08-1.21-2.07-.63l-26.87,15.54a4.25,4.25,0,0,0-1.51,1.6l-6.06-3.49a4.38,4.38,0,0,1,1.52-1.61l26.86-15.54a4.79,4.79,0,0,1,4.3,0l1.76,1A4.72,4.72,0,0,1,355.8,189.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "337.545px 195.585px"
    },
    className: "animable",
    id: "el31lnd0t7nuz"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--mail--inject-5",
    d: "M349.24,200.34a.58.58,0,0,0-.57,0l-17.56,10.14a.56.56,0,0,0-.28.49v16.66a.58.58,0,0,0,.28.49.6.6,0,0,0,.28.08.6.6,0,0,0,.29-.08L349.24,218a.58.58,0,0,0,.28-.49V200.83A.58.58,0,0,0,349.24,200.34ZM340,215.17,332.54,211l14.85-8.57Zm-2.58-.16L332,225.33V211.94Zm1,.56,1.52.87a.58.58,0,0,0,.28.07.55.55,0,0,0,.49-.28l1.72-2.95,5.54,4.15-15.11,8.72Zm4.58-3.28,5.43-9.35v13.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "340.175px 214.233px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chat--inject-5",
    className: "animable",
    style: {
      transformOrigin: "292.215px 238.279px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-5",
    className: "animable",
    style: {
      transformOrigin: "292.215px 238.279px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.82,216.24a4.73,4.73,0,0,0-2.15-3.72l-1.75-1a4.72,4.72,0,0,0-4.3,0L275.76,227a4.76,4.76,0,0,0-2.15,3.73v29.55a4.75,4.75,0,0,0,2.15,3.73l1.75,1a4.72,4.72,0,0,0,4.3,0l26.86-15.54a4.73,4.73,0,0,0,2.15-3.72Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "292.215px 238.265px"
    },
    id: "elor9xzzard8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el32v9x5uun75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.61,260.32a4.75,4.75,0,0,0,2.15,3.73l1.75,1a4.76,4.76,0,0,0,3.93.17c-1,.39-1.78-.18-1.78-1.41V234.26a4.43,4.43,0,0,1,.63-2.12l-6.05-3.49a4.36,4.36,0,0,0-.63,2.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "277.525px 247.107px"
    },
    className: "animable",
    id: "elxbldbhcptae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elffyoto66pp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.75,215.63c-.25-.91-1.08-1.2-2.07-.63l-26.87,15.54a4.3,4.3,0,0,0-1.52,1.61l-6.05-3.5a4.35,4.35,0,0,1,1.52-1.6l26.85-15.54a4.75,4.75,0,0,1,4.31,0l1.76,1A4.75,4.75,0,0,1,310.75,215.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "292.495px 221.572px"
    },
    className: "animable",
    id: "eldt5df2g35na"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chat--inject-5",
    d: "M304.22,232.51l-8.5,4.91a4.88,4.88,0,0,0-1.85,3.91v6.15c0,1.57.83,2.37,1.85,1.78l4.51-2.61,3.14,3.3a.27.27,0,0,0,.35,0,.79.79,0,0,0,.23-.22,1.43,1.43,0,0,0,.25-.95l-.63-4.09.65-.37a4.88,4.88,0,0,0,1.85-3.91v-6.15C306.07,232.72,305.24,231.92,304.22,232.51Zm.89,8.79a2.33,2.33,0,0,1-.89,1.87l-1.24.72a1,1,0,0,0-.38.49,1.38,1.38,0,0,0-.09.68l.38,2.23-2.11-1.9a.26.26,0,0,0-.35,0l-4.71,2.72c-.49.29-.89-.1-.89-.85v-6.46a2.33,2.33,0,0,1,.89-1.87l8.5-4.91c.49-.28.89.1.89.85Zm-12.31,1.88-.16.09a.86.86,0,0,0-.28.31l-4.11,7,.24-4a.84.84,0,0,0-.07-.61.27.27,0,0,0-.39-.08l-1.16.68c-.61.35-1.1-.13-1.1-1.05v-9.28a2.88,2.88,0,0,1,1.1-2.31l13.62-7.86c.6-.35,1.09.12,1.09,1v5.09c0,.41.22.61.48.46a1.26,1.26,0,0,0,.49-1V226.6c0-1.74-.93-2.63-2.06-2l-13.62,7.87a5.43,5.43,0,0,0-2.06,4.35v9.27c0,1.75.92,2.64,2.06,2l.51-.3-.08,4.61c-.06.34,0,.63.18.72a.29.29,0,0,0,.28,0,.82.82,0,0,0,.28-.3l4.76-8.13h0a1.25,1.25,0,0,0,.48-1C293.28,243.23,293.07,243,292.8,243.18Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "295.44px 238.777px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Phone--inject-5",
    className: "animable",
    style: {
      transformOrigin: "247.08px 264.329px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-5",
    className: "animable",
    style: {
      transformOrigin: "247.08px 264.329px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.69,242.29a4.76,4.76,0,0,0-2.16-3.73l-1.75-1a4.72,4.72,0,0,0-4.3,0l-26.86,15.53a4.76,4.76,0,0,0-2.15,3.73v29.56a4.73,4.73,0,0,0,2.15,3.72l1.75,1a4.72,4.72,0,0,0,4.3,0l26.86-15.53a4.78,4.78,0,0,0,2.16-3.73Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "247.08px 264.33px"
    },
    id: "elydb044a1osp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaxkrguh685a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.47,286.37a4.73,4.73,0,0,0,2.15,3.72l1.75,1a4.8,4.8,0,0,0,3.93.18c-1,.38-1.78-.19-1.78-1.42V260.31a4.36,4.36,0,0,1,.63-2.12l-6.05-3.5a4.36,4.36,0,0,0-.63,2.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "232.385px 273.148px"
    },
    className: "animable",
    id: "elexqneq95ipf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1aum7xy9eryi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.61,241.67c-.25-.91-1.08-1.2-2.07-.63l-26.87,15.54a4.2,4.2,0,0,0-1.51,1.61l-6.06-3.5a4.43,4.43,0,0,1,1.52-1.6l26.86-15.54a4.79,4.79,0,0,1,4.3,0l1.76,1A4.75,4.75,0,0,1,265.61,241.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "247.355px 247.615px"
    },
    className: "animable",
    id: "elzncli13zoya"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone--inject-5",
    className: "animable",
    style: {
      transformOrigin: "249.955px 266.46px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.08,276.92h-.15c-6-.51-10.16-4.57-12.5-12.05a8.61,8.61,0,0,1,2.12-8.13A2,2,0,0,1,245,256h0c1.31,0,3.51,3.66,3.56,5.11a5.13,5.13,0,0,1-.95,2.88,3.35,3.35,0,0,0-.44,3.07c.71,2.06,1.88,3.15,3.57,3.36.44.05.83-.37,1.14-1.26.52-1.51,1.16-2.4,2-2.72a2,2,0,0,1,1.7.13l.27.13a13.63,13.63,0,0,1,1.39.76h0l.24.15c.84.51,1.57,1.13,1.16,3.16s-2,5.15-3.48,6a.49.49,0,0,1-.19.07l-.14,0A3.27,3.27,0,0,1,254.08,276.92ZM245,257.09c-.12,0-.34.15-.59.42a7.46,7.46,0,0,0-1.87,7c2.22,7.09,6,10.77,11.52,11.24a1.47,1.47,0,0,0,.5-.07l.1,0c1.06-.67,2.45-3.19,2.86-5.18.28-1.41-.08-1.63-.64-2l-.28-.17h0a11.65,11.65,0,0,0-1.26-.69l-.28-.14a.84.84,0,0,0-.76-.09c-.32.13-.81.59-1.31,2-.63,1.83-1.63,2.11-2.34,2-2.14-.26-3.66-1.65-4.51-4.12a4.44,4.44,0,0,1,.54-4,4,4,0,0,0,.79-2.24C247.39,260,245.52,257.25,245,257.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.955px 266.46px"
    },
    id: "elwjhgpy9ecwe",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5",
    className: "animable",
    style: {
      transformOrigin: "291.985px 128.841px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5",
    className: "animable",
    style: {
      transformOrigin: "291.985px 128.841px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.42,23.6,230.68,90.33a5.75,5.75,0,0,0-2.6,4.51V228.67a5.74,5.74,0,0,0,2.61,4.5l1.63.93a5.79,5.79,0,0,0,5.21,0l115.74-66.84a5.76,5.76,0,0,0,2.61-4.51V29a5.71,5.71,0,0,0-2.62-4.5l-1.62-.93A5.78,5.78,0,0,0,346.42,23.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "291.98px 128.841px"
    },
    id: "el52v6npry98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.88,162.92c0,2.29-1.61,3.75-3.61,4.9L238.53,233.5c-2,1.14-3.6.22-3.6-2.08V99.89h0a7.16,7.16,0,0,1,3.58-6.21L352.27,28a2.41,2.41,0,0,1,3.61,2.08h0Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "295.405px 130.834px"
    },
    id: "eller3pamsb3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.47,28.65h0a1.4,1.4,0,0,1,1.4,1.4V162.92c0,1.56-.95,2.8-3.1,4L238,232.63a2.39,2.39,0,0,1-1.11.36c-.86,0-1-1-1-1.57V99.89A6.18,6.18,0,0,1,239,94.55L352.77,28.84a1.37,1.37,0,0,1,.7-.19m0-1a2.34,2.34,0,0,0-1.2.33L238.51,93.68a7.16,7.16,0,0,0-3.58,6.21V231.42c0,1.63.81,2.57,2,2.57a3.29,3.29,0,0,0,1.61-.49l113.74-65.68c2-1.15,3.61-2.61,3.61-4.9V30.05a2.42,2.42,0,0,0-2.41-2.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "295.41px 130.815px"
    },
    id: "elnb1xhl3ufv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.88,29v1A2.41,2.41,0,0,0,352.27,28L238.51,93.68a7.08,7.08,0,0,0-2.62,2.62l0,.08-7-4.06a5.39,5.39,0,0,1,1.88-2L346.42,23.6a5.73,5.73,0,0,1,5.21,0l1.63.93A5.73,5.73,0,0,1,355.88,29Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "292.385px 59.6768px"
    },
    id: "el6hahmgmbdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,124c-.07,0-.12,0-.16,0l-.08-.08-1.72-3v3.9a.54.54,0,0,1-.05.21.24.24,0,0,1-.12.14l-.49.29c-.05,0-.09,0-.12,0a.21.21,0,0,1-.05-.15v-6.11a.54.54,0,0,1,.05-.21.24.24,0,0,1,.12-.14l.43-.25c.07,0,.12,0,.16,0l.08.09,1.72,2.94v-3.9a.54.54,0,0,1,.05-.21.28.28,0,0,1,.12-.14l.49-.29a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.15v6.12a.54.54,0,0,1-.05.21.33.33,0,0,1-.12.14Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "248.295px 121.265px"
    },
    id: "elb3hfahg88f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,119.39a2.88,2.88,0,0,1,.12-.49,2.83,2.83,0,0,1,.25-.57,3,3,0,0,1,.4-.56,2.17,2.17,0,0,1,.55-.45,1.33,1.33,0,0,1,.56-.19.56.56,0,0,1,.44.12.93.93,0,0,1,.28.46,2.89,2.89,0,0,1,.1.8v2.78a.54.54,0,0,1-.05.21c0,.07-.07.12-.12.14l-.47.27a.08.08,0,0,1-.11,0,.17.17,0,0,1-.05-.15v-.31a2.72,2.72,0,0,1-.38.68,1.79,1.79,0,0,1-.61.55,1.21,1.21,0,0,1-.48.17.48.48,0,0,1-.35-.11.87.87,0,0,1-.22-.34,1.75,1.75,0,0,1-.07-.55,2.42,2.42,0,0,1,.3-1.19,3.37,3.37,0,0,1,.8-1l1-.84c0-.26-.06-.41-.17-.46a.51.51,0,0,0-.41.08,1,1,0,0,0-.24.2,2.29,2.29,0,0,0-.17.28.55.55,0,0,1-.1.16.28.28,0,0,1-.1.09l-.57.33s-.08,0-.11,0S250.89,119.46,250.89,119.39Zm1,2.08a1.56,1.56,0,0,0,.37-.31,1.91,1.91,0,0,0,.28-.4,2.5,2.5,0,0,0,.16-.43,1.64,1.64,0,0,0,.06-.42v-.1l-.84.71a1.45,1.45,0,0,0-.36.41.71.71,0,0,0-.11.4c0,.14,0,.21.13.22A.5.5,0,0,0,251.92,121.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "252.135px 119.988px"
    },
    id: "elm5qx36pvw8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,116.16a2.47,2.47,0,0,1,.36-.62,1.36,1.36,0,0,1,.44-.4.82.82,0,0,1,.63-.15.75.75,0,0,1,.39.36,3.57,3.57,0,0,1,.19-.45,3,3,0,0,1,.25-.4,2.21,2.21,0,0,1,.28-.32A2.47,2.47,0,0,1,258,114a.86.86,0,0,1,.59-.15.58.58,0,0,1,.38.26,1.63,1.63,0,0,1,.2.59,5,5,0,0,1,.06.81V118a.54.54,0,0,1-.05.21.42.42,0,0,1-.12.14l-.47.27a.08.08,0,0,1-.11,0,.17.17,0,0,1-.05-.15V116a1.35,1.35,0,0,0-.16-.81c-.11-.11-.26-.1-.45,0a1,1,0,0,0-.42.49,2.25,2.25,0,0,0-.19,1v2.54a.54.54,0,0,1-.05.21.24.24,0,0,1-.12.14l-.46.27s-.09,0-.12,0a.25.25,0,0,1-.05-.16v-2.5a1.26,1.26,0,0,0-.16-.8q-.17-.16-.45,0a1.17,1.17,0,0,0-.43.51,2.29,2.29,0,0,0-.18,1v2.5a.46.46,0,0,1-.16.35l-.47.27a.11.11,0,0,1-.12,0,.21.21,0,0,1,0-.15v-4.41a.54.54,0,0,1,0-.21.35.35,0,0,1,.12-.14l.47-.28a.09.09,0,0,1,.11,0,.2.2,0,0,1,0,.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.828px 117.436px"
    },
    id: "ely2ix9ua9yug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,115.44a5.45,5.45,0,0,1,.11-1.06,5.18,5.18,0,0,1,.3-1,3.61,3.61,0,0,1,.48-.81,2,2,0,0,1,.62-.56,1,1,0,0,1,.63-.17.71.71,0,0,1,.47.25,1.56,1.56,0,0,1,.31.59,3.17,3.17,0,0,1,.1.86V114a.41.41,0,0,1-.05.21.37.37,0,0,1-.11.15l-2.06,1.18a.85.85,0,0,0,.06.35.38.38,0,0,0,.16.19.34.34,0,0,0,.23,0,.77.77,0,0,0,.26-.1,1.16,1.16,0,0,0,.32-.24,1.31,1.31,0,0,0,.2-.28l.11-.16a.4.4,0,0,1,.12-.1l.49-.28q.08,0,.12,0s.05.08.05.16a1.38,1.38,0,0,1-.1.39,3,3,0,0,1-.26.56,4.58,4.58,0,0,1-.44.6,2.92,2.92,0,0,1-.61.49,1.06,1.06,0,0,1-.62.17.64.64,0,0,1-.48-.25,1.54,1.54,0,0,1-.3-.63A4,4,0,0,1,259.89,115.44Zm1.51-2.29a1.08,1.08,0,0,0-.3.26,1.15,1.15,0,0,0-.21.33,1.78,1.78,0,0,0-.14.36,2.33,2.33,0,0,0-.06.33l1.39-.8a1.26,1.26,0,0,0,0-.27.46.46,0,0,0-.11-.22.26.26,0,0,0-.21-.09A.61.61,0,0,0,261.4,113.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.4px 114.564px"
    },
    id: "elhffn5kd5riu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,91a2.15,2.15,0,0,0-.56.47,2.85,2.85,0,0,0-.37.6,4.11,4.11,0,0,0-.21.68c0,.24-.08.48-.1.73s0,.32,0,.56v.72c0,.25,0,.49,0,.72s0,.41,0,.54a3.38,3.38,0,0,0,.1.61,1.13,1.13,0,0,0,.21.44.52.52,0,0,0,.38.17,1,1,0,0,0,.55-.18,2.18,2.18,0,0,0,.49-.37,2.22,2.22,0,0,0,.39-.51,3.12,3.12,0,0,0,.27-.67,3.58,3.58,0,0,0,.09-.83l-.82.48a.15.15,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-1.6a.88.88,0,0,1,.08-.34.56.56,0,0,1,.19-.23l2.38-1.37a.15.15,0,0,1,.19,0,.36.36,0,0,1,.07.25v1.93a7.28,7.28,0,0,1-.23,1.88,8.12,8.12,0,0,1-.65,1.69,6.67,6.67,0,0,1-1,1.38,4.87,4.87,0,0,1-1.21,1,2.58,2.58,0,0,1-1.26.4,1.39,1.39,0,0,1-.95-.34,2.09,2.09,0,0,1-.6-1,5.53,5.53,0,0,1-.25-1.44c0-.41,0-.85,0-1.32s0-.94,0-1.38a8.78,8.78,0,0,1,.24-1.72,8.67,8.67,0,0,1,.61-1.66,6.59,6.59,0,0,1,.95-1.43,4.87,4.87,0,0,1,1.26-1.06,2.63,2.63,0,0,1,1.24-.4,1.59,1.59,0,0,1,.94.24,1.87,1.87,0,0,1,.6.7,2.56,2.56,0,0,1,.24,1,.66.66,0,0,1-.06.27.52.52,0,0,1-.16.19l-1.31.75c-.1.06-.18.06-.23,0l-.16-.18a.82.82,0,0,0-.38-.28Q269.43,90.77,268.94,91Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "268.926px 94.0238px"
    },
    id: "el3vor3kwgeg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,93.07a1.2,1.2,0,0,0,.09.53.42.42,0,0,0,.21.24.44.44,0,0,0,.28,0,1.2,1.2,0,0,0,.31-.13,2,2,0,0,0,.47-.36,1.84,1.84,0,0,0,.29-.42l.15-.27a.63.63,0,0,1,.17-.13l1.28-.74c.14-.08.22,0,.22.21a2.53,2.53,0,0,1-.15.64,6.17,6.17,0,0,1-.46,1,7.45,7.45,0,0,1-.8,1.14,4.55,4.55,0,0,1-1.17,1,2.33,2.33,0,0,1-1.14.37,1.09,1.09,0,0,1-.83-.32,2.16,2.16,0,0,1-.52-1,6.76,6.76,0,0,1-.17-1.62,9,9,0,0,1,.17-1.72,7.5,7.5,0,0,1,.52-1.6,5.63,5.63,0,0,1,.83-1.33,4.2,4.2,0,0,1,1.14-1,1.94,1.94,0,0,1,1.22-.34,1.3,1.3,0,0,1,.83.49,2.53,2.53,0,0,1,.46,1.06,6.09,6.09,0,0,1,.14,1.38v.42A.78.78,0,0,1,278,91a.57.57,0,0,1-.19.23Zm.89-3.42a1.47,1.47,0,0,0-.63.75,3,3,0,0,0-.26,1l1.77-1a1.2,1.2,0,0,0-.25-.7C275.9,89.5,275.69,89.5,275.42,89.65Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "275.417px 91.684px"
    },
    id: "elfc46gcp7mmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,89.18a.9.9,0,0,0,.1.48c.07.09.17.09.33,0l.78-.45a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24V91a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-.93.54a1.73,1.73,0,0,1-.84.28.91.91,0,0,1-.65-.21,1.52,1.52,0,0,1-.41-.71,3.8,3.8,0,0,1-.15-1.16V87.75l-.73.42a.14.14,0,0,1-.18,0,.29.29,0,0,1-.08-.24V86.38a.67.67,0,0,1,.08-.33.49.49,0,0,1,.18-.23l.73-.42V82.93a.8.8,0,0,1,.08-.33.45.45,0,0,1,.19-.23l1.24-.72a.13.13,0,0,1,.18,0,.31.31,0,0,1,.08.24v2.47l1.11-.65a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v1.53a.8.8,0,0,1-.08.33.45.45,0,0,1-.19.23l-1.11.64Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "280.639px 86.9981px"
    },
    id: "eli3hqp4fql1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.45,79.57a.88.88,0,0,1-.08.34.49.49,0,0,1-.19.23l-1.24.71a.14.14,0,0,1-.18,0,.33.33,0,0,1-.08-.24V79.07a.84.84,0,0,1,.08-.34.54.54,0,0,1,.18-.23l1.24-.71c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.24Zm0,8.71a.8.8,0,0,1-.08.33.41.41,0,0,1-.19.23l-1.24.72a.14.14,0,0,1-.18,0,.34.34,0,0,1-.08-.25v-7a.84.84,0,0,1,.08-.34.54.54,0,0,1,.18-.23l1.24-.71c.08,0,.14,0,.19,0a.33.33,0,0,1,.08.24Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "286.565px 83.6914px"
    },
    id: "elwyg5o7183zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,84.6a.8.8,0,0,1-.08.33.57.57,0,0,1-.19.23l-1.24.71a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24V81.79a1.56,1.56,0,0,0-.2-.93c-.14-.18-.36-.19-.65,0a1.5,1.5,0,0,0-.65.77,3.2,3.2,0,0,0-.2,1.16V86.6a.67.67,0,0,1-.08.33.49.49,0,0,1-.18.23l-1.24.72c-.08,0-.14,0-.19,0a.37.37,0,0,1-.08-.25V80.56a.8.8,0,0,1,.08-.33.45.45,0,0,1,.19-.23l1.19-.68a.14.14,0,0,1,.19,0,.33.33,0,0,1,.07.24v.35c.06-.13.12-.28.2-.43a2.52,2.52,0,0,1,.29-.46,3.86,3.86,0,0,1,.38-.44,2.58,2.58,0,0,1,.52-.38,2.06,2.06,0,0,1,.87-.3.91.91,0,0,1,.67.24,1.8,1.8,0,0,1,.44.83,5.7,5.7,0,0,1,.16,1.45Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "291.215px 82.8892px"
    },
    id: "el7gdwze8gdal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.18,78.85a.82.82,0,0,0,.1.48c.06.09.17.09.32,0l.79-.46a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v1.53a.67.67,0,0,1-.08.33.49.49,0,0,1-.18.23l-.94.54a1.85,1.85,0,0,1-.84.28.85.85,0,0,1-.64-.22,1.44,1.44,0,0,1-.42-.7,3.87,3.87,0,0,1-.14-1.16V77.41l-.73.42a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24V76.05a.8.8,0,0,1,.08-.33.5.5,0,0,1,.19-.23l.73-.42V72.6a.78.78,0,0,1,.07-.33.51.51,0,0,1,.19-.23l1.24-.72a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25V74l1.11-.64a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24v1.53a.78.78,0,0,1-.07.33.57.57,0,0,1-.19.23l-1.11.64Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "298.531px 76.6543px"
    },
    id: "eldz5rfhsmzd6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.62,73.11c0,.14,0,.34,0,.57s0,.44,0,.59a6.37,6.37,0,0,1-.21,1.49,7,7,0,0,1-.54,1.43,6.17,6.17,0,0,1-.83,1.23,4.39,4.39,0,0,1-1.09.9,2.23,2.23,0,0,1-1.09.35,1.21,1.21,0,0,1-.83-.27,1.77,1.77,0,0,1-.54-.8,4,4,0,0,1-.22-1.24c0-.14,0-.34,0-.57s0-.44,0-.59a6.52,6.52,0,0,1,.21-1.49,6.94,6.94,0,0,1,.54-1.42,6.43,6.43,0,0,1,.84-1.24,4.23,4.23,0,0,1,1.09-.91,2.23,2.23,0,0,1,1.09-.35,1.26,1.26,0,0,1,.83.28,1.63,1.63,0,0,1,.54.8A3.78,3.78,0,0,1,306.62,73.11ZM303,76.27a1,1,0,0,0,.27.74.56.56,0,0,0,.64,0,1.63,1.63,0,0,0,.63-.69,2.59,2.59,0,0,0,.27-1.06,4.35,4.35,0,0,0,0-.53,3.78,3.78,0,0,0,0-.5,1,1,0,0,0-.27-.74c-.16-.13-.37-.12-.63,0a1.65,1.65,0,0,0-.64.69,2.55,2.55,0,0,0-.27,1.06c0,.15,0,.33,0,.52S303,76.12,303,76.27Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "303.945px 75.2306px"
    },
    id: "el0uzajpwadhil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5,69.65a.8.8,0,0,1,.08-.33.44.44,0,0,1,.18-.23l1.25-.72a.14.14,0,0,1,.18,0,.36.36,0,0,1,.08.25v3.83a1.76,1.76,0,0,0,.19.94c.12.19.33.2.62,0a1.35,1.35,0,0,0,.61-.75,3.35,3.35,0,0,0,.18-1.15V67.7a.8.8,0,0,1,.08-.33.51.51,0,0,1,.19-.23l1.24-.72a.15.15,0,0,1,.19,0,.37.37,0,0,1,.07.25v7.06a.78.78,0,0,1-.07.33.57.57,0,0,1-.19.23l-1.14.66a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-.35a3.25,3.25,0,0,1-.19.44,2.76,2.76,0,0,1-.28.45,3.85,3.85,0,0,1-.39.44,2.58,2.58,0,0,1-.52.38c-.64.37-1.15.38-1.52,0a3.19,3.19,0,0,1-.57-2.3Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "310.056px 71.3687px"
    },
    id: "elzwgjqu521sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,68.11c0,.16,0,.35,0,.55s0,.37,0,.52a1,1,0,0,0,.27.72c.15.13.36.12.62,0a1.54,1.54,0,0,0,.5-.43,2,2,0,0,0,.28-.56,1.81,1.81,0,0,1,.12-.28.4.4,0,0,1,.17-.19l1.29-.75a.17.17,0,0,1,.19,0,.31.31,0,0,1,.07.25,4.3,4.3,0,0,1-.13.79,5.08,5.08,0,0,1-.41,1.16,6.08,6.08,0,0,1-.8,1.27,4.4,4.4,0,0,1-1.28,1.08,2.39,2.39,0,0,1-1,.35,1.27,1.27,0,0,1-.84-.22,1.63,1.63,0,0,1-.57-.76,3.77,3.77,0,0,1-.23-1.32c0-.14,0-.34,0-.6s0-.45,0-.61a6.42,6.42,0,0,1,.23-1.58,6.88,6.88,0,0,1,.57-1.43,6,6,0,0,1,.84-1.18,4.38,4.38,0,0,1,1-.83,2.31,2.31,0,0,1,1.28-.4,1.34,1.34,0,0,1,.8.34,1.51,1.51,0,0,1,.41.7,2.4,2.4,0,0,1,.13.64.64.64,0,0,1-.07.32.54.54,0,0,1-.19.24l-1.29.74a.15.15,0,0,1-.17,0,.61.61,0,0,1-.12-.15.44.44,0,0,0-.28-.24.74.74,0,0,0-.5.15,1.55,1.55,0,0,0-.62.69A2.58,2.58,0,0,0,315.35,68.11Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "316.232px 68.1277px"
    },
    id: "eloco3x2zou8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,66.63a.67.67,0,0,1-.08.33.49.49,0,0,1-.18.23l-1.24.72c-.08,0-.14,0-.19,0a.33.33,0,0,1-.08-.24V63.82a1.69,1.69,0,0,0-.2-.93c-.14-.18-.36-.18-.65,0a1.44,1.44,0,0,0-.65.76,3.24,3.24,0,0,0-.2,1.16v3.83a.81.81,0,0,1-.08.34.45.45,0,0,1-.19.23l-1.24.71a.13.13,0,0,1-.18,0,.29.29,0,0,1-.08-.24V59.72a.67.67,0,0,1,.08-.33.49.49,0,0,1,.18-.23l1.24-.72a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v3.23A4.2,4.2,0,0,1,322,61a2.71,2.71,0,0,1,.82-.77,1.91,1.91,0,0,1,.86-.29.85.85,0,0,1,.68.24,1.75,1.75,0,0,1,.43.82,5.28,5.28,0,0,1,.16,1.45Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "322.379px 64.1811px"
    },
    id: "elwaumik3y6qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.07 130.3 346.05 72.57 346.05 81.45 246.07 139.18 246.07 130.3",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "296.06px 105.875px"
    },
    id: "elcfxkrosdm4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,149.38a.09.09,0,0,1,.11,0,.17.17,0,0,1,0,.15v.67a.41.41,0,0,1,0,.21.37.37,0,0,1-.11.15l-2.7,1.55q-.08,0-.12,0a.25.25,0,0,1-.05-.16v-6.11a.54.54,0,0,1,.05-.21.24.24,0,0,1,.12-.14l2.65-1.53a.07.07,0,0,1,.11,0,.17.17,0,0,1,.05.15v.67a.41.41,0,0,1-.05.21.27.27,0,0,1-.11.14l-2,1.15v1.5l1.85-1.07a.1.1,0,0,1,.12,0,.21.21,0,0,1,0,.15v.68a.49.49,0,0,1,0,.2.31.31,0,0,1-.12.15L247.43,149v1.57Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "248.099px 148.022px"
    },
    id: "elj9fhg4ozdjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,145.15a2.73,2.73,0,0,1,.36-.63,1.59,1.59,0,0,1,.43-.4.87.87,0,0,1,.64-.14.64.64,0,0,1,.38.36,3.44,3.44,0,0,1,.45-.85,3,3,0,0,1,.27-.32A1.57,1.57,0,0,1,254,143a.91.91,0,0,1,.58-.16.55.55,0,0,1,.38.27,1.41,1.41,0,0,1,.2.58,5.17,5.17,0,0,1,.06.82V147a.37.37,0,0,1,0,.2.37.37,0,0,1-.11.15l-.47.27a.1.1,0,0,1-.12,0,.21.21,0,0,1,0-.15V145a1.28,1.28,0,0,0-.16-.81q-.15-.16-.45,0a1.22,1.22,0,0,0-.42.49,2.33,2.33,0,0,0-.18,1v2.55a.54.54,0,0,1,0,.21.34.34,0,0,1-.12.14l-.47.27a.08.08,0,0,1-.11,0,.17.17,0,0,1,0-.15v-2.5a1.35,1.35,0,0,0-.16-.81c-.11-.1-.26-.1-.45,0a1.17,1.17,0,0,0-.43.51,2.24,2.24,0,0,0-.18,1v2.5a.54.54,0,0,1,0,.21.31.31,0,0,1-.12.15l-.46.27a.1.1,0,0,1-.12,0,.21.21,0,0,1,0-.15v-4.42a.49.49,0,0,1,0-.2.31.31,0,0,1,.12-.15l.46-.27a.1.1,0,0,1,.12,0,.21.21,0,0,1,0,.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "252.955px 146.444px"
    },
    id: "el2ipockkpv2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,143.09a2.77,2.77,0,0,1,.11-.49,3.25,3.25,0,0,1,.26-.58,2.57,2.57,0,0,1,.4-.55,2,2,0,0,1,.55-.45,1.31,1.31,0,0,1,.56-.2.62.62,0,0,1,.44.13.89.89,0,0,1,.28.46,2.94,2.94,0,0,1,.09.8V145a.41.41,0,0,1-.05.21.33.33,0,0,1-.11.14l-.47.27a.09.09,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-.31a2.4,2.4,0,0,1-.37.68,1.94,1.94,0,0,1-.62.55,1.12,1.12,0,0,1-.47.17.51.51,0,0,1-.35-.11.77.77,0,0,1-.22-.34,1.77,1.77,0,0,1-.08-.55,2.49,2.49,0,0,1,.31-1.2,3.47,3.47,0,0,1,.8-1l1-.85c0-.25-.05-.41-.16-.45a.47.47,0,0,0-.41.08.61.61,0,0,0-.24.2,1.48,1.48,0,0,0-.17.28l-.1.16a.41.41,0,0,1-.1.09l-.57.33a.11.11,0,0,1-.11,0S256,143.16,256,143.09Zm1,2.07a1.52,1.52,0,0,0,.37-.3,1.76,1.76,0,0,0,.27-.4,1.82,1.82,0,0,0,.17-.44,1.51,1.51,0,0,0,.05-.42v-.09l-.83.71a1.42,1.42,0,0,0-.36.4.78.78,0,0,0-.12.41c0,.13.05.21.14.22A.53.53,0,0,0,257,145.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "257.235px 143.689px"
    },
    id: "elgmvckn7jkz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.17,137.67a.07.07,0,0,1,.11,0,.21.21,0,0,1,.05.15v.74a.49.49,0,0,1-.05.2.37.37,0,0,1-.11.15l-.53.3c-.05,0-.09,0-.12,0a.21.21,0,0,1,0-.15v-.74a.49.49,0,0,1,0-.2.31.31,0,0,1,.12-.15Zm.13,6.38a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.46.27a.1.1,0,0,1-.12,0,.21.21,0,0,1-.05-.15V140.1a.53.53,0,0,1,.05-.2.31.31,0,0,1,.12-.15l.46-.27a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.915px 141.172px"
    },
    id: "el6p6ge7t7kgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,143.1a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.46.26q-.07,0-.12,0a.25.25,0,0,1-.05-.16v-6.2a.54.54,0,0,1,.05-.21.31.31,0,0,1,.12-.15l.46-.27a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.6px 140.215px"
    },
    id: "ellgbegv0c73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,138.35a2.77,2.77,0,0,1,.11-.49,2.88,2.88,0,0,1,.26-.57,2.39,2.39,0,0,1,.4-.56,2,2,0,0,1,.55-.45,1.41,1.41,0,0,1,.56-.2.58.58,0,0,1,.43.13.78.78,0,0,1,.28.46,2.56,2.56,0,0,1,.1.8v2.78a.41.41,0,0,1-.05.21.33.33,0,0,1-.11.14l-.47.27a.09.09,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-.31a2.67,2.67,0,0,1-.37.68,1.94,1.94,0,0,1-.62.55,1.12,1.12,0,0,1-.47.17.51.51,0,0,1-.35-.11.7.7,0,0,1-.22-.34,1.73,1.73,0,0,1-.08-.55,2.43,2.43,0,0,1,.31-1.19,3.37,3.37,0,0,1,.8-1l1-.85c0-.25,0-.4-.16-.45a.47.47,0,0,0-.41.08.71.71,0,0,0-.24.2,1.48,1.48,0,0,0-.17.28l-.1.16a.41.41,0,0,1-.1.09l-.58.33a.09.09,0,0,1-.1,0S264.19,138.42,264.2,138.35Zm1,2.07a1.74,1.74,0,0,0,.37-.3,1.76,1.76,0,0,0,.27-.4,1.82,1.82,0,0,0,.17-.44,2,2,0,0,0,0-.42v-.09l-.83.71a1.67,1.67,0,0,0-.37.4.87.87,0,0,0-.11.41c0,.14.05.21.14.22A.53.53,0,0,0,265.23,140.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "265.436px 138.944px"
    },
    id: "els24o0u26ny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,134.31a1,1,0,0,1,.34-.14.64.64,0,0,1,.27,0,.54.54,0,0,1,.19.08.47.47,0,0,1,.13.11v-2a.54.54,0,0,1,.05-.21A.33.33,0,0,1,270,132l.47-.27a.09.09,0,0,1,.12,0,.21.21,0,0,1,.05.15v6.21a.54.54,0,0,1-.05.21.28.28,0,0,1-.12.14l-.47.27a.08.08,0,0,1-.11,0,.21.21,0,0,1-.05-.15v-.22c0,.08-.08.16-.13.26a2.49,2.49,0,0,1-.19.3,2.44,2.44,0,0,1-.27.29,1.8,1.8,0,0,1-.34.26.82.82,0,0,1-.56.13.7.7,0,0,1-.42-.24,1.5,1.5,0,0,1-.28-.55,3.06,3.06,0,0,1-.11-.78,3.11,3.11,0,0,1,0-.32c0-.13,0-.24,0-.34a4.8,4.8,0,0,1,.11-.9,4.66,4.66,0,0,1,.28-.87,4.07,4.07,0,0,1,.42-.74A1.75,1.75,0,0,1,268.94,134.31Zm-.57,2.62a4.68,4.68,0,0,0,0,.53c0,.39.1.64.24.74a.45.45,0,0,0,.51,0,1.36,1.36,0,0,0,.51-.57,2.2,2.2,0,0,0,.24-.93c0-.09,0-.22,0-.36a3.33,3.33,0,0,0,0-.35.89.89,0,0,0-.24-.65.45.45,0,0,0-.51,0,1.43,1.43,0,0,0-.51.57A2.41,2.41,0,0,0,268.37,136.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "269.088px 135.647px"
    },
    id: "el1ljrsc8le3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.75,132.11a.94.94,0,0,1,.34-.14.58.58,0,0,1,.26,0,.43.43,0,0,1,.2.07l.13.11v-2a.52.52,0,0,1,0-.21.58.58,0,0,1,.12-.14l.47-.27a.09.09,0,0,1,.11,0,.17.17,0,0,1,.05.15v6.21a.41.41,0,0,1-.05.21.27.27,0,0,1-.11.14l-.47.27a.09.09,0,0,1-.12,0,.25.25,0,0,1,0-.16v-.21l-.13.25a2.61,2.61,0,0,1-.2.3,2.32,2.32,0,0,1-.26.3,2.13,2.13,0,0,1-.34.25.9.9,0,0,1-.56.14.66.66,0,0,1-.42-.25,1.5,1.5,0,0,1-.28-.55,2.65,2.65,0,0,1-.11-.77c0-.1,0-.2,0-.33s0-.24,0-.34a4.1,4.1,0,0,1,.11-.9,4.66,4.66,0,0,1,.28-.87,3.15,3.15,0,0,1,.42-.74A1.87,1.87,0,0,1,272.75,132.11Zm-.58,2.62a4.68,4.68,0,0,0,0,.53c0,.39.11.64.25.74a.45.45,0,0,0,.51,0,1.43,1.43,0,0,0,.51-.57,2.35,2.35,0,0,0,.24-.92c0-.1,0-.22,0-.37s0-.26,0-.35a.89.89,0,0,0-.24-.64.42.42,0,0,0-.51,0,1.34,1.34,0,0,0-.51.56A2.55,2.55,0,0,0,272.17,134.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "272.906px 133.447px"
    },
    id: "elj7jv441y6sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.82,131a1.27,1.27,0,0,0-.54.56,2.28,2.28,0,0,0-.16.91v2.46a.41.41,0,0,1-.05.21.27.27,0,0,1-.11.14l-.47.27a.09.09,0,0,1-.12,0,.21.21,0,0,1-.05-.15V131a.54.54,0,0,1,.05-.21.24.24,0,0,1,.12-.14l.47-.27a.08.08,0,0,1,.11,0,.17.17,0,0,1,.05.15v.22a3.07,3.07,0,0,1,.34-.55,1.6,1.6,0,0,1,.48-.4l.28-.16a.09.09,0,0,1,.11,0,.17.17,0,0,1,.05.15v.63a.35.35,0,0,1-.05.2.37.37,0,0,1-.11.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "276.351px 132.597px"
    },
    id: "el6xgks6obtp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.68,131.81a5.53,5.53,0,0,1,.11-1.06,4.87,4.87,0,0,1,.3-1,3.47,3.47,0,0,1,.48-.82,2,2,0,0,1,.62-.56,1,1,0,0,1,.62-.17.71.71,0,0,1,.48.25,1.49,1.49,0,0,1,.31.59,3.22,3.22,0,0,1,.1.86v.42a.41.41,0,0,1-.05.21.37.37,0,0,1-.11.15l-2.06,1.18a.85.85,0,0,0,.06.35.38.38,0,0,0,.16.19.34.34,0,0,0,.23,0,.77.77,0,0,0,.26-.1,1.16,1.16,0,0,0,.32-.24,1.31,1.31,0,0,0,.2-.28c.05-.07.08-.13.11-.16a.4.4,0,0,1,.12-.1l.49-.28q.07,0,.12,0a.17.17,0,0,1,.05.15,1.35,1.35,0,0,1-.1.4,3.88,3.88,0,0,1-.26.56,4.58,4.58,0,0,1-.44.6,2.63,2.63,0,0,1-.61.49,1.16,1.16,0,0,1-.62.18.68.68,0,0,1-.48-.26,1.54,1.54,0,0,1-.3-.63A4,4,0,0,1,277.68,131.81Zm1.51-2.29a1.08,1.08,0,0,0-.3.26,1.46,1.46,0,0,0-.22.33,2.6,2.6,0,0,0-.13.36,2.33,2.33,0,0,0-.06.33l1.39-.8a1.26,1.26,0,0,0,0-.27.57.57,0,0,0-.11-.22.27.27,0,0,0-.21-.09A.61.61,0,0,0,279.19,129.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279.19px 130.909px"
    },
    id: "elstbjdenrdom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.11,129.73a.21.21,0,0,0,0-.15.21.21,0,0,0-.15,0,1.35,1.35,0,0,0-.29,0l-.45.11a1,1,0,0,1-.45,0,.52.52,0,0,1-.29-.16.81.81,0,0,1-.15-.35,3.49,3.49,0,0,1,0-.5,2.31,2.31,0,0,1,.09-.61,2.75,2.75,0,0,1,.25-.63,3,3,0,0,1,.39-.57,2,2,0,0,1,.54-.44,1.45,1.45,0,0,1,.53-.21.77.77,0,0,1,.41,0,.57.57,0,0,1,.26.25.93.93,0,0,1,.1.38.33.33,0,0,1-.05.21.31.31,0,0,1-.12.15l-.47.27a.16.16,0,0,1-.14,0l-.1-.06a.3.3,0,0,0-.15,0,.65.65,0,0,0-.27.11,1,1,0,0,0-.33.28.59.59,0,0,0-.14.38.35.35,0,0,0,0,.16.17.17,0,0,0,.13.05l.27,0,.44-.11a.74.74,0,0,1,.77.12,1.2,1.2,0,0,1,.22.82,2.18,2.18,0,0,1-.09.6,2.73,2.73,0,0,1-.27.64,2.7,2.7,0,0,1-.43.59,2.5,2.5,0,0,1-.57.46,1.33,1.33,0,0,1-.58.21.72.72,0,0,1-.42-.06.62.62,0,0,1-.26-.27,1,1,0,0,1-.1-.41.39.39,0,0,1,0-.21.35.35,0,0,1,.12-.14l.48-.28a.14.14,0,0,1,.14,0l.1.09a.21.21,0,0,0,.16.06.75.75,0,0,0,.32-.12l.19-.12.18-.17.14-.19A.54.54,0,0,0,283.11,129.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "282.596px 128.966px"
    },
    id: "eli6jbup88ez8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,127.88a.18.18,0,0,0,0-.14.21.21,0,0,0-.15,0l-.29,0-.45.11a1,1,0,0,1-.45,0,.5.5,0,0,1-.29-.17.76.76,0,0,1-.15-.34,2.53,2.53,0,0,1,0-.5,2.69,2.69,0,0,1,.08-.61,3.07,3.07,0,0,1,.65-1.21,2,2,0,0,1,.53-.44,1.7,1.7,0,0,1,.54-.21.73.73,0,0,1,.4,0,.51.51,0,0,1,.26.24.94.94,0,0,1,.11.39.43.43,0,0,1,0,.21.24.24,0,0,1-.12.14l-.47.28c-.06,0-.11,0-.14,0l-.1-.06a.33.33,0,0,0-.15,0,.59.59,0,0,0-.28.11,1.18,1.18,0,0,0-.32.27.54.54,0,0,0-.14.38.32.32,0,0,0,0,.16.16.16,0,0,0,.13.05l.26,0,.44-.11q.56-.14.78.12a1.22,1.22,0,0,1,.22.82,2.31,2.31,0,0,1-.09.61,2.92,2.92,0,0,1-.27.64,3.41,3.41,0,0,1-.43.59,2.32,2.32,0,0,1-.58.45,1.41,1.41,0,0,1-.57.22.69.69,0,0,1-.42-.07.64.64,0,0,1-.27-.27.91.91,0,0,1-.09-.41.38.38,0,0,1,0-.2.49.49,0,0,1,.12-.15l.48-.27c.06,0,.1,0,.13,0l.11.1a.25.25,0,0,0,.16.05.55.55,0,0,0,.31-.11l.2-.13.18-.17a1.33,1.33,0,0,0,.14-.19A.54.54,0,0,0,286.31,127.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.846px 127.115px"
    },
    id: "elayfkjx8v136",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.07 156.94 346.05 99.21 346.05 108.09 246.07 165.82 246.07 156.94",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "296.06px 132.515px"
    },
    id: "elcizmqp06uul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,174.45l1.17-3.8a1.6,1.6,0,0,1,.08-.2.46.46,0,0,1,.18-.21l.42-.24a.11.11,0,0,1,.12,0,.21.21,0,0,1,0,.15v6.12a.52.52,0,0,1,0,.21.43.43,0,0,1-.12.14l-.5.29a.11.11,0,0,1-.12,0,.21.21,0,0,1,0-.15v-3.7l-.79,2.59a1.13,1.13,0,0,1-.09.2.4.4,0,0,1-.14.17l-.32.18c-.06,0-.11,0-.14,0a.41.41,0,0,1-.09-.1l-.8-1.67v3.7a.54.54,0,0,1-.05.21.28.28,0,0,1-.12.14l-.49.29a.1.1,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-6.12a.54.54,0,0,1,.05-.21.28.28,0,0,1,.12-.14l.41-.24c.09-.05.15-.05.19,0l.08.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "248.627px 174.386px"
    },
    id: "elsfrog23a7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38,173.64a5.51,5.51,0,0,1,.1-1.06,4.87,4.87,0,0,1,.3-1,3.84,3.84,0,0,1,.48-.82,2.19,2.19,0,0,1,.63-.56,1,1,0,0,1,.62-.17.71.71,0,0,1,.48.25,1.42,1.42,0,0,1,.3.59,3.21,3.21,0,0,1,.11.86v.42a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-2,1.18a.85.85,0,0,0,.06.35.42.42,0,0,0,.15.19.35.35,0,0,0,.23,0,.64.64,0,0,0,.27-.1,1.11,1.11,0,0,0,.31-.24,1.37,1.37,0,0,0,.21-.28.85.85,0,0,1,.11-.16.4.4,0,0,1,.12-.1l.49-.28a.09.09,0,0,1,.12,0,.18.18,0,0,1,0,.16,1.29,1.29,0,0,1-.09.39,3.14,3.14,0,0,1-.27.56,3.82,3.82,0,0,1-.44.6,2.39,2.39,0,0,1-.6.49,1.17,1.17,0,0,1-.63.18.7.7,0,0,1-.48-.26,1.54,1.54,0,0,1-.3-.63A4,4,0,0,1,251.38,173.64Zm1.51-2.29a1.13,1.13,0,0,0-.31.26,1.85,1.85,0,0,0-.21.33,1.74,1.74,0,0,0-.13.36,2.33,2.33,0,0,0-.06.33l1.39-.8a2.56,2.56,0,0,0,0-.27.46.46,0,0,0-.11-.22.25.25,0,0,0-.2-.09A.58.58,0,0,0,252.89,171.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "252.89px 172.739px"
    },
    id: "eljoprrpa13th",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,171.56a.27.27,0,0,0,0-.15.23.23,0,0,0-.16,0,1.28,1.28,0,0,0-.28.05l-.46.11a1,1,0,0,1-.44,0,.49.49,0,0,1-.29-.16.81.81,0,0,1-.15-.35,2.47,2.47,0,0,1,0-.5,2.28,2.28,0,0,1,.08-.61,3.3,3.3,0,0,1,.25-.63,3.09,3.09,0,0,1,.4-.57,1.86,1.86,0,0,1,.53-.44,1.42,1.42,0,0,1,.54-.21.73.73,0,0,1,.4,0,.53.53,0,0,1,.26.25.94.94,0,0,1,.11.39.53.53,0,0,1,0,.2.38.38,0,0,1-.12.15l-.47.27a.17.17,0,0,1-.14,0l-.1-.06a.24.24,0,0,0-.15,0,.63.63,0,0,0-.28.1,1.06,1.06,0,0,0-.32.28.55.55,0,0,0-.15.38.34.34,0,0,0,0,.16.14.14,0,0,0,.13.05l.26,0,.44-.11c.37-.09.62,0,.77.12a1.2,1.2,0,0,1,.23.82,2.18,2.18,0,0,1-.09.6,4,4,0,0,1-.27.64,3.07,3.07,0,0,1-.43.59,2.35,2.35,0,0,1-.58.46,1.34,1.34,0,0,1-.57.21.7.7,0,0,1-.42-.06.59.59,0,0,1-.27-.27,1.12,1.12,0,0,1-.1-.41.54.54,0,0,1,.05-.21.24.24,0,0,1,.12-.14l.47-.28c.07,0,.11,0,.14,0l.11.09a.21.21,0,0,0,.16.06.61.61,0,0,0,.31-.12,1,1,0,0,0,.19-.12,1,1,0,0,0,.18-.17.77.77,0,0,0,.14-.19A.42.42,0,0,0,256.81,171.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.337px 170.841px"
    },
    id: "eluw0qzr0rvzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,169.71a.18.18,0,0,0-.05-.14.21.21,0,0,0-.15,0,2.11,2.11,0,0,0-.28.05l-.46.11a1,1,0,0,1-.45,0,.48.48,0,0,1-.28-.17.59.59,0,0,1-.15-.34,2.49,2.49,0,0,1-.05-.5,2.25,2.25,0,0,1,.09-.61,2.85,2.85,0,0,1,.25-.63,3.27,3.27,0,0,1,.39-.58,2.27,2.27,0,0,1,.54-.44,1.86,1.86,0,0,1,.54-.21.74.74,0,0,1,.4,0,.55.55,0,0,1,.26.24.93.93,0,0,1,.1.39.39.39,0,0,1,0,.21.43.43,0,0,1-.12.14l-.48.27c-.06,0-.1.05-.13,0a.3.3,0,0,1-.11-.06.26.26,0,0,0-.14,0,.68.68,0,0,0-.28.11,1.4,1.4,0,0,0-.33.27.6.6,0,0,0-.14.39.22.22,0,0,0,0,.15s.06,0,.12,0l.27,0,.44-.11a.74.74,0,0,1,.77.12,1.22,1.22,0,0,1,.23.82,2.35,2.35,0,0,1-.1.61,3.44,3.44,0,0,1-.26.64,4.66,4.66,0,0,1-.43.59,2.74,2.74,0,0,1-.58.45,1.51,1.51,0,0,1-.58.22.72.72,0,0,1-.42-.07.62.62,0,0,1-.26-.27,1.08,1.08,0,0,1-.1-.41.39.39,0,0,1,.05-.2.31.31,0,0,1,.12-.15l.47-.27c.06,0,.11,0,.14,0l.1.09a.29.29,0,0,0,.17.05.57.57,0,0,0,.31-.11l.19-.13a1,1,0,0,0,.18-.17.85.85,0,0,0,.14-.19A.42.42,0,0,0,260,169.71Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.437px 168.965px"
    },
    id: "elk11hjg2k9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,166.57a3.13,3.13,0,0,1,.12-.49,2.83,2.83,0,0,1,.25-.57,3,3,0,0,1,.4-.56,2.13,2.13,0,0,1,.55-.44,1.23,1.23,0,0,1,.56-.2.6.6,0,0,1,.44.12.93.93,0,0,1,.28.46,3,3,0,0,1,.1.8v2.78a.54.54,0,0,1-.05.21c0,.07-.07.12-.12.14l-.47.27a.08.08,0,0,1-.11,0,.21.21,0,0,1-.05-.16v-.31a2.72,2.72,0,0,1-.38.68,1.79,1.79,0,0,1-.61.55,1.07,1.07,0,0,1-.48.17.52.52,0,0,1-.35-.1.92.92,0,0,1-.22-.35,1.73,1.73,0,0,1-.07-.54,2.43,2.43,0,0,1,.3-1.2,3.51,3.51,0,0,1,.8-1l1-.84c0-.26-.06-.41-.17-.46a.51.51,0,0,0-.41.08.83.83,0,0,0-.24.21,1.59,1.59,0,0,0-.17.27.55.55,0,0,1-.1.16.28.28,0,0,1-.1.09l-.57.33a.08.08,0,0,1-.11,0S261.45,166.64,261.46,166.57Zm1,2.08a1.36,1.36,0,0,0,.37-.31,1.56,1.56,0,0,0,.27-.4,1.92,1.92,0,0,0,.17-.43,1.64,1.64,0,0,0,.06-.42V167l-.84.71a1.45,1.45,0,0,0-.36.41.72.72,0,0,0-.11.41c0,.13,0,.2.13.21A.44.44,0,0,0,262.49,168.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "262.705px 167.164px"
    },
    id: "elkdp5f73rtuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37,168.4a1,1,0,0,0,.26-.22,1.43,1.43,0,0,0,.25-.33,2.53,2.53,0,0,0,.18-.44,1.81,1.81,0,0,0,.07-.52v-.35a2.08,2.08,0,0,1-.13.26c-.05.09-.12.19-.19.29a3.65,3.65,0,0,1-.27.3,1.76,1.76,0,0,1-.34.25.87.87,0,0,1-.55.14.71.71,0,0,1-.43-.25A1.49,1.49,0,0,1,265,167a3,3,0,0,1-.12-.77v-.67a4.84,4.84,0,0,1,.12-.9,4.65,4.65,0,0,1,.27-.87,3.58,3.58,0,0,1,.43-.74,2,2,0,0,1,.55-.5,1.29,1.29,0,0,1,.34-.14.63.63,0,0,1,.27,0,.4.4,0,0,1,.19.07.5.5,0,0,1,.13.11v-.22a.54.54,0,0,1,.05-.21.28.28,0,0,1,.12-.14l.46-.27a.09.09,0,0,1,.12,0,.21.21,0,0,1,.05.15v4.44a4.44,4.44,0,0,1-.41,2,2.89,2.89,0,0,1-1.15,1.24,1.52,1.52,0,0,1-.58.21.9.9,0,0,1-.47-.07.77.77,0,0,1-.31-.31,1,1,0,0,1-.13-.47.41.41,0,0,1,.05-.21.31.31,0,0,1,.12-.15l.41-.24a.12.12,0,0,1,.15,0l.11.1a.28.28,0,0,0,.22.14A.74.74,0,0,0,266.37,168.4Zm-.74-3.25a4.68,4.68,0,0,0,0,.53c0,.4.11.64.25.74a.45.45,0,0,0,.51,0,1.34,1.34,0,0,0,.5-.57,2.19,2.19,0,0,0,.24-.92c0-.1,0-.22,0-.37s0-.26,0-.35a.85.85,0,0,0-.24-.64.4.4,0,0,0-.5,0,1.34,1.34,0,0,0-.51.56A2.55,2.55,0,0,0,265.63,165.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.431px 165.762px"
    },
    id: "elvc1tnjhwmma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.62,163.69a5.44,5.44,0,0,1,.1-1.06,4.57,4.57,0,0,1,.31-1,4.08,4.08,0,0,1,.47-.82,2.35,2.35,0,0,1,.63-.56,1,1,0,0,1,.62-.16.74.74,0,0,1,.48.24,1.42,1.42,0,0,1,.3.59,3.26,3.26,0,0,1,.11.86v.43a.54.54,0,0,1-.05.21.24.24,0,0,1-.12.14l-2.05,1.19a.88.88,0,0,0,.06.35.42.42,0,0,0,.15.19.45.45,0,0,0,.23,0,1,1,0,0,0,.27-.1,1.69,1.69,0,0,0,.32-.25,2.34,2.34,0,0,0,.2-.27,1,1,0,0,1,.11-.17l.12-.09.49-.29a.11.11,0,0,1,.12,0,.17.17,0,0,1,0,.15,1.4,1.4,0,0,1-.09.4,3.14,3.14,0,0,1-.27.56,3.35,3.35,0,0,1-.44.59,2.19,2.19,0,0,1-.6.49,1,1,0,0,1-.63.18.67.67,0,0,1-.47-.25,1.43,1.43,0,0,1-.31-.63A4,4,0,0,1,268.62,163.69Zm1.51-2.29a1.26,1.26,0,0,0-.31.25,2.39,2.39,0,0,0-.21.34,1.55,1.55,0,0,0-.13.36,2.33,2.33,0,0,0-.06.33l1.39-.8a1.28,1.28,0,0,0-.05-.27.49.49,0,0,0-.11-.23.34.34,0,0,0-.2-.09A.61.61,0,0,0,270.13,161.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.127px 162.789px"
    },
    id: "elfjbr7ihnt8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.07 183.58 346.05 125.86 346.05 156.94 246.07 214.66 246.07 183.58",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "296.06px 170.26px"
    },
    id: "elu0k8d8liksf",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5",
    className: "animable",
    style: {
      transformOrigin: "165.293px 235.292px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5",
    className: "animable",
    style: {
      transformOrigin: "157.01px 235.292px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.45,68.42,95.71,135.15a5.77,5.77,0,0,0-2.6,4.51V396.75a5.72,5.72,0,0,0,2.61,4.5l1.63.93a5.76,5.76,0,0,0,5.21,0L218.3,335.33a5.76,5.76,0,0,0,2.61-4.51v-257a5.72,5.72,0,0,0-2.62-4.5l-1.62-.93A5.78,5.78,0,0,0,211.45,68.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.01px 235.292px"
    },
    id: "elbrm8lg7pwtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.91,331c0,2.29-1.61,3.75-3.61,4.89L103.56,401.58c-2,1.15-3.6.22-3.6-2.08V144.71h0a7.16,7.16,0,0,1,3.58-6.21L217.3,72.79a2.41,2.41,0,0,1,3.61,2.08h0Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "160.435px 237.271px"
    },
    id: "el6xk8qhhylzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,73.47h0a1.4,1.4,0,0,1,1.4,1.4V331c0,1.55-1,2.79-3.1,4L103.06,400.71a2.28,2.28,0,0,1-1.11.36c-.86,0-1-1-1-1.57V144.71a6.19,6.19,0,0,1,3.08-5.34L217.8,73.66a1.37,1.37,0,0,1,.7-.19m0-1a2.43,2.43,0,0,0-1.2.32L103.54,138.5a7.16,7.16,0,0,0-3.58,6.21V399.5c0,1.63.81,2.57,2,2.57a3.29,3.29,0,0,0,1.61-.49L217.3,335.9c2-1.14,3.61-2.6,3.61-4.89V74.87a2.41,2.41,0,0,0-2.41-2.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "160.435px 237.27px"
    },
    id: "el5tntq724gex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.91,73.84v1a2.41,2.41,0,0,0-3.61-2.08L103.54,138.51a7.06,7.06,0,0,0-2.62,2.61l0,.08-7-4.06a5.36,5.36,0,0,1,1.88-2L211.45,68.42a5.81,5.81,0,0,1,5.22,0l1.62.93A5.73,5.73,0,0,1,220.91,73.84Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "157.415px 104.5px"
    },
    id: "el47y845mm6w3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,142.14a.32.32,0,0,1,0-.17v-.84l-1.31.76c-.08,0-.11,0-.11-.12v-.3a.86.86,0,0,1,0-.17.9.9,0,0,1,0-.16l1.39-3.81a1.13,1.13,0,0,1,.07-.15.24.24,0,0,1,.09-.08l.18-.11q.09,0,.12,0s0,.09,0,.19v2.93l.29-.17c.06,0,.09,0,.12,0a.41.41,0,0,1,0,.19v.2a.58.58,0,0,1,0,.21.28.28,0,0,1-.12.12l-.29.17v.84a.41.41,0,0,1,0,.21.22.22,0,0,1-.12.13l-.22.13C122.24,142.16,122.2,142.17,122.17,142.14Zm.06-1.78v-2.09l-1,2.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "121.883px 139.574px"
    },
    id: "elq6fd2yodvil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.73,140.73a2.81,2.81,0,0,1-.38-1.71,5.41,5.41,0,0,1,.39-2.16,2.6,2.6,0,0,1,1.08-1.31,1.46,1.46,0,0,1,.53-.2.56.56,0,0,1,.41.06.08.08,0,0,1,0,.07.38.38,0,0,1,0,.1l-.12.44a.31.31,0,0,1,0,.09h-.06a.74.74,0,0,0-.67.1,1.9,1.9,0,0,0-.74.91,4.06,4.06,0,0,0-.27,1.59,2.27,2.27,0,0,0,.26,1.3c.18.21.42.23.72.05a1.72,1.72,0,0,0,.32-.23,1.66,1.66,0,0,0,.26-.28v-1.37l-.55.32s-.09,0-.11,0a.26.26,0,0,1,0-.18v-.19a.43.43,0,0,1,0-.22.25.25,0,0,1,.11-.12l.88-.5c.06,0,.1,0,.13,0a.47.47,0,0,1,0,.22v1.94a.72.72,0,0,1,0,.17.24.24,0,0,1,0,.13,2.71,2.71,0,0,1-1,1C124.35,141.05,124,141,123.73,140.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "124.635px 138.145px"
    },
    id: "elttt0i0e61rr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,134a2,2,0,0,1-.76,1.61c-.42.25-.76-.08-.76-.73a2,2,0,0,1,.76-1.61C134.46,133.05,134.8,133.38,134.8,134Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.04px 134.448px"
    },
    id: "ell0sozhzq3os",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,131.38a4.57,4.57,0,0,0-1.77,2.66c-.07.24,0,.46.08.53h0c.14.09.36-.09.44-.39A3.24,3.24,0,0,1,134,132.3a.81.81,0,0,1,1.25.44c.08.2.3.14.44-.12h0a.77.77,0,0,0,.08-.63A1.14,1.14,0,0,0,134,131.38Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.003px 132.877px"
    },
    id: "elej14vukgakr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,129.5a7.12,7.12,0,0,0-2.72,3.87c-.09.25-.06.51.06.59h0c.14.09.35-.09.44-.37a5.82,5.82,0,0,1,2.22-3.17,1.47,1.47,0,0,1,2.22.6c.1.18.3.12.44-.13h0a.75.75,0,0,0,.06-.66A1.81,1.81,0,0,0,134,129.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "133.999px 131.568px"
    },
    id: "elw6rim72ywm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,117.16a.08.08,0,0,1,.1,0,.21.21,0,0,1,0,.12v.76a.58.58,0,0,1,0,.18.27.27,0,0,1-.1.11l-.47.27a.07.07,0,0,1-.09,0,.17.17,0,0,1,0-.13v-.76a.35.35,0,0,1,0-.17.29.29,0,0,1,.09-.12Zm0,2.72a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.12v.76a.47.47,0,0,1,0,.17.25.25,0,0,1-.1.12l-.47.27a.06.06,0,0,1-.09,0s0-.06,0-.12v-.76a.35.35,0,0,1,0-.17.24.24,0,0,1,.09-.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "159.619px 119.241px"
    },
    id: "eljw0a0qhnrar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.54,119.51a.08.08,0,0,1-.09,0,.17.17,0,0,1,0-.13v-.94l-1.56.91a.08.08,0,0,1-.1,0,.16.16,0,0,1,0-.12v-.55a.66.66,0,0,1,0-.21c0-.07,0-.14.08-.22l1.54-3.86a.63.63,0,0,1,.21-.31l.38-.22a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v3.1l.43-.25a.08.08,0,0,1,.1,0,.15.15,0,0,1,0,.12v.55a.33.33,0,0,1,0,.17.25.25,0,0,1-.1.12l-.43.25V119a.33.33,0,0,1,0,.17.25.25,0,0,1-.1.12Zm-.13-2.05V115.8l-.86,2.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "162.21px 116.683px"
    },
    id: "el9vu56al5tpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.37,122.47a.08.08,0,0,1-.1,0,.22.22,0,0,1,0-.13v-.94l-1.56.91a.08.08,0,0,1-.1,0,.21.21,0,0,1,0-.12v-.56a.45.45,0,0,1,0-.2,1.87,1.87,0,0,1,.07-.22l1.55-3.86a.57.57,0,0,1,.2-.31l.39-.23a.07.07,0,0,1,.09,0,.17.17,0,0,1,0,.13V120l.44-.25a.06.06,0,0,1,.09,0s0,.06,0,.12v.55a.33.33,0,0,1,0,.17.24.24,0,0,1-.09.12l-.44.25V122a.35.35,0,0,1,0,.17.24.24,0,0,1-.09.12Zm-.14-2v-1.66l-.86,2.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "157.025px 119.641px"
    },
    id: "elhb6qv9gk9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,113.11a.35.35,0,0,1,0-.17.25.25,0,0,1,.1-.12l1.89-1.09a.09.09,0,0,1,.1,0,.22.22,0,0,1,0,.13v.55a.53.53,0,0,1,0,.17.25.25,0,0,1-.1.12l-1.41.82-.06,1a1.23,1.23,0,0,1,.27-.25l.22-.15a1.2,1.2,0,0,1,.52-.18.6.6,0,0,1,.42.1.87.87,0,0,1,.28.4,2.06,2.06,0,0,1,.1.71,3.62,3.62,0,0,1-.1.91,3.17,3.17,0,0,1-.29.75,2.21,2.21,0,0,1-.42.58,2.72,2.72,0,0,1-.51.4,1.64,1.64,0,0,1-.6.22.62.62,0,0,1-.41-.1.77.77,0,0,1-.25-.35,1.61,1.61,0,0,1-.09-.52.25.25,0,0,1,0-.17.24.24,0,0,1,.09-.12l.41-.24s.07,0,.09,0a.15.15,0,0,1,.06.11.55.55,0,0,0,.09.23.29.29,0,0,0,.16.09.33.33,0,0,0,.19,0,1.38,1.38,0,0,0,.22-.1,1.15,1.15,0,0,0,.46-.51,1.61,1.61,0,0,0,.18-.76.54.54,0,0,0-.18-.48.41.41,0,0,0-.46,0,1.25,1.25,0,0,0-.24.18.67.67,0,0,0-.14.16l-.1.14a.38.38,0,0,1-.12.1l-.46.27a.08.08,0,0,1-.1,0s0-.06,0-.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "165.558px 114.864px"
    },
    id: "elpmaf8ujn1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.67 151.14 107.67 149.52 109.07 148.71 109.07 150.33 107.67 151.14",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "108.37px 149.925px"
    },
    id: "elbpwtfzb00kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.77 149.93 109.77 146.69 111.17 145.88 111.17 149.12 109.77 149.93",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "110.47px 147.905px"
    },
    id: "elod8vcopc0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.87 148.71 111.87 143.86 113.27 143.05 113.27 147.9 111.87 148.71",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.57px 145.88px"
    },
    id: "eleigden1hsy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.97 147.5 113.97 141.03 115.38 140.22 115.38 146.69 113.97 147.5",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "114.675px 143.86px"
    },
    id: "eljdyjohm6bl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,85.42a.37.37,0,0,0-.52-.17l-5.24,3a2,2,0,0,0-.6,1.59v2.94a1.67,1.67,0,0,0,.23.94.42.42,0,0,0,.21.19.31.31,0,0,0,.31,0l5.23-3a2,2,0,0,0,.6-1.59V86.36A1.79,1.79,0,0,0,212.4,85.42Zm-6,7.93a.83.83,0,0,1-.09-.43V90a1.57,1.57,0,0,1,.47-1.21l5.23-3a.21.21,0,0,1,.17,0,.17.17,0,0,1,.06.06.79.79,0,0,1,.09.43v2.94a1.57,1.57,0,0,1-.46,1.21l-5.24,3A.15.15,0,0,1,206.41,93.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "209.33px 89.5767px"
    },
    id: "eltlo5rojs4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,88.71v3.48l-.82.47a.11.11,0,0,1-.16-.09V90a1.21,1.21,0,0,1,.34-.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "207.289px 90.6911px"
    },
    id: "el6pg80yhf0o9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.16 88.5 209.14 87.93 209.14 91.41 208.16 91.97 208.16 88.5",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "208.65px 89.95px"
    },
    id: "elbv77s76cgn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.52 87.72 210.51 87.14 210.51 90.63 209.52 91.2 209.52 87.72",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "210.015px 89.17px"
    },
    id: "eluyjd2zeh11r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.87,86.59V89.1a1.3,1.3,0,0,1-.65,1.12l-.33.19V86.93l.78-.45A.13.13,0,0,1,211.87,86.59Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "211.38px 88.4348px"
    },
    id: "elt68f0fsxcrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.82,86.27c.14-.09.26.33.26.93v.55a2.24,2.24,0,0,1-.26,1.27l-.27.18V86.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "212.82px 87.7289px"
    },
    id: "elem5yeh705et",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.09 95.16 203.18 90.64 201.61 97.26 200.87 94.51 198.09 95.16",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "200.635px 93.95px"
    },
    id: "eljr3x2rllblj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1,158,192,110.74c1.36-.78,2.46-.14,2.46,1.42v7.65a5.45,5.45,0,0,1-2.46,4.26L110.1,171.35c-1.36.78-2.46.15-2.46-1.42v-7.64A5.42,5.42,0,0,1,110.1,158Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "151.05px 141.046px"
    },
    id: "elcn2fq3cfb26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,118.1a.94.94,0,0,1-.82-.47.93.93,0,0,1,.34-1.29L211,110a1,1,0,0,1,1,1.64L201.11,118A.9.9,0,0,1,200.64,118.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.974px 114.033px"
    },
    id: "el7nn9p4u25ny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,113.43a.94.94,0,0,1-.48-1.76L211,105.35a.95.95,0,1,1,1,1.63l-10.83,6.32A.9.9,0,0,1,200.64,113.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.069px 109.32px"
    },
    id: "elns3s5c17pvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,108.77a1,1,0,0,1-.48-1.77L211,100.68a1,1,0,0,1,1.3.34.94.94,0,0,1-.34,1.29l-10.83,6.33A1,1,0,0,1,200.64,108.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.107px 104.668px"
    },
    id: "elfmdhfd2fxrq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5",
    className: "animable",
    style: {
      transformOrigin: "168.718px 292.966px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-5",
    className: "animable",
    style: {
      transformOrigin: "134.07px 373.411px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,344.75V399.6c0,2.21,1.56,3.1,3.46,2l34.31-19.81,3.33-1.92,26.49-15.3c.15-5,.28-9.22.37-12.33.12-3.59.18-5.68.18-5.68Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.07px 373.411px"
    },
    id: "ellsrekwbzzjq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5",
    className: "animable",
    style: {
      transformOrigin: "168.718px 273.471px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.5,271.07a27.12,27.12,0,0,0,.58-4.22c.56-6.82,4.09-12.87,7.88-18.41.64-.94,1.3-1.88,2-2.82a13.92,13.92,0,0,0,.92-1.39c.24-.47.46-.85,1.12-.72a1.88,1.88,0,0,1,1.1.82,5.56,5.56,0,0,1,.67,4.48,26.65,26.65,0,0,1-1.63,4.36c-.46,1.11.86.77,1.46.52,2.94-1.23,5.89-5.34,7.74-7.87,1.21-1.66,2.11-3.53,3.57-5a6.26,6.26,0,0,1,3.27-1.87c.85-.15,1.68,0,1.77,1.08a4.36,4.36,0,0,1-.52,1.93c-.52,1.28-1,2.44-.4,3.8a10.81,10.81,0,0,1,1,2.57c.17,1.17-.36,2.33-.33,3.51s.63,1.92.76,2.91-.54,2.52-.9,3.5a28.46,28.46,0,0,1-3.52,6.54,54.31,54.31,0,0,1-7.63,8.34,14.92,14.92,0,0,0-4,4.81,31.67,31.67,0,0,0-1.69,6.08c-.54,2.58-1,5.18-1.57,7.76-5.74,28-8.61,29.55-12.25,33.72-2.2,2.52-8.55,4.9-17.18-4C179.14,311.6,160.82,286,160.82,286L157,251.79s3.41.92,7.72,2.15c4,1.15,8.26,5.19,11.12,9.71C181.75,273,197,297.34,197,297.34S205.34,274.71,206.5,271.07Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "197.238px 283.353px"
    },
    id: "elralrcckbw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,252.11c6.32.84,10,2.8,13.73,7.18s18.05,28.28,18.05,28.28-4.88,10.52-18.05,16.07l-16.37-21.46Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "174.29px 277.875px"
    },
    id: "elj8odvbm30pn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpwsbo4upal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.72,252.11c6.32.84,10,2.8,13.73,7.18s18.05,28.28,18.05,28.28-4.88,10.52-18.05,16.07l-16.37-21.46Z",
    style: {
      opacity: 0.15,
      transformOrigin: "174.29px 277.875px"
    },
    className: "animable",
    id: "els71gsdkknjf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197,297.34a53.79,53.79,0,0,0-4.33,15.29S190.85,302,195,294.1Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "194.636px 303.365px"
    },
    id: "eld3av00uhxsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,257.85C219,261.7,217.41,267,216,269a12.07,12.07,0,0,0,3.21-5.3C219.9,260.5,219.4,259.09,218.61,257.85Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "217.768px 263.425px"
    },
    id: "elkyalnuk4hpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.25,352.51c-13.24,9.4-56.59,12.54-69.29,4.14V255.11l1-.2,12.43-2.62,6.73-1.42,1.71-.36h0l6-1.26,15.64.91h0l4.71.28h0l.46,0s5.44.65,11.09,1.63c.21.19.4.39.61.6h0c3.92,4.23,7.3,15,8.26,26.53.36,4.39.62,11,.82,18.41,0,0,0,.46,0,.69C170,321,169.25,352.51,169.25,352.51Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "134.8px 305.389px"
    },
    id: "elt28xxpz6rq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5",
    className: "animable",
    style: {
      transformOrigin: "134.212px 227.257px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.09,211.79c2.77-6.36.06-14.8-3.26-18.76-4.79-5.73-12.24-8.2-23.48-7.5-8.55.53-16.95,4.08-18.55,12.85-6.87,2.05-6.09,13.33-4.38,18.31,3.47,10.09,10.29,18.88,10.4,24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.239px 213.052px"
    },
    id: "ell8bcs4rcjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,235.54c-1.35,4.88-4.17,8.45-8.68,9.15a37.43,37.43,0,0,1-7.11,0l.17,6.21c6.07,5.19,3.85,12-.2,18.16-5-5.59-10.78-7.59-15.81-9.8a16.1,16.1,0,0,1-7.33-7.1l-.64-21s-2.76,3.14-7.31.17a9.92,9.92,0,0,1-3.08-12.14c2.25-4.76,6.76-2.79,8.15-1.35s3,4.16,4.17,3.78a4.17,4.17,0,0,0,2.79-2.85,25.49,25.49,0,0,0,1.48-9.22,12.59,12.59,0,0,0,3.53-2.72,11.47,11.47,0,0,0,3.06-7.06c9.74-3,20.95-1.61,25,1.52,2.33,4.11,2.41,13.65,2.8,19.15C160.49,226.49,160.22,231.46,159.08,235.54Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "134.212px 233.583px"
    },
    id: "elks5jk1uourl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.28,244.73c-5-.28-15-2.61-17.68-5.39s-3.81-8.48-3.81-8.48.4,7.19,2.47,10.36,7.28,4.56,10.45,5.35a76.62,76.62,0,0,0,8.67,1.31Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "132.585px 239.37px"
    },
    id: "el2kszoa23oc2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,269.1c-2.61-1.6-8.37-8.14-11.24-5.1s-4.39,3.87-6.29,3.31-6.06-4.69-8.79-7.7a17.45,17.45,0,0,1-3.6-7.35,47.47,47.47,0,0,0,3.85-5.35c1.3-2.3,1-2.95,2.68-3.06l.15,4.34s1,2.37,5.74,5.57S139.89,261.72,143.26,269.1Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "128.3px 256.475px"
    },
    id: "elm4a7z1h2zwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltsweczsyozo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.26,269.1c-2.61-1.6-8.37-8.14-11.24-5.1s-4.39,3.87-6.29,3.31-6.06-4.69-8.79-7.7a17.45,17.45,0,0,1-3.6-7.35,47.47,47.47,0,0,0,3.85-5.35c1.3-2.3,1-2.95,2.68-3.06l.15,4.34s1,2.37,5.74,5.57S139.89,261.72,143.26,269.1Z",
    style: {
      opacity: 0.15,
      transformOrigin: "128.3px 256.475px"
    },
    className: "animable",
    id: "elql5ztnn9dc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,269.1c1.55-1.42,4.08-8,4.75-7.84,1,.29,2.78,4.85,3.64,3.79,1.36-1.68.95-9.36-1.32-12.15s-5.29-5.76-7-6.05l.12,4.09a16.58,16.58,0,0,1,1.68,6.6C145.13,259.87,143.58,266.87,143.26,269.1Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "147.844px 257.975px"
    },
    id: "elixs8xumge78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo3o6wdjm6ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.26,269.1c1.55-1.42,4.08-8,4.75-7.84,1,.29,2.78,4.85,3.64,3.79,1.36-1.68.95-9.36-1.32-12.15s-5.29-5.76-7-6.05l.12,4.09a16.58,16.58,0,0,1,1.68,6.6C145.13,259.87,143.58,266.87,143.26,269.1Z",
    style: {
      opacity: 0.15,
      transformOrigin: "147.844px 257.975px"
    },
    className: "animable",
    id: "eld0zgylvqupt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.13,217.33a2,2,0,0,1-2,2.09,2.1,2.1,0,1,1,2-2.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.031px 217.322px"
    },
    id: "elmkfwohdhk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,210.88l-4.08,2.76a2.59,2.59,0,0,1,.69-3.51A2.41,2.41,0,0,1,137.31,210.88Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "135.067px 211.684px"
    },
    id: "elyxjk6dfglbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,212.77l-4.48-2.14a2.38,2.38,0,0,1,3.24-1.22A2.6,2.6,0,0,1,156.87,212.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "154.736px 210.969px"
    },
    id: "el8u70ztvbts2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.36,217.2a2,2,0,0,1-2,2.1,2.1,2.1,0,1,1,2-2.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "153.261px 217.202px"
    },
    id: "eljb4w5ug6k7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.76 212.99 146.22 227.49 154 225.14 144.76 212.99",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "149.38px 220.24px"
    },
    id: "elavf3y105g49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,230.86l8.34,1.85a4.2,4.2,0,0,1-5,3.39A4.48,4.48,0,0,1,140.12,230.86Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "144.246px 233.525px"
    },
    id: "elq2tcshceki8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.46,236.1c.17,0,.34,0,.52.06a3.89,3.89,0,0,0-3.88-3.79A4.43,4.43,0,0,0,143.46,236.1Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "142.04px 234.265px"
    },
    id: "elfjezfo9m67",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103,288.1,100,295.48V255.11S108.62,271.69,103,288.1Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "102.451px 275.295px"
    },
    id: "eli5e1y3ivqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr6jesmhlucr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,288.1,100,295.48V255.11S108.62,271.69,103,288.1Z",
    style: {
      opacity: 0.15,
      transformOrigin: "102.451px 275.295px"
    },
    className: "animable",
    id: "elz5b7ylfxyf"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,224.73a24.92,24.92,0,0,1,5.4,2.51,4.76,4.76,0,0,1,1.66,6.46l-2.06-.4s1.06-2.41-.18-3.71-4.85-2.4-4.85-2.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "164.105px 229.215px"
    },
    id: "el005a2bsj2j0o4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,232.37c-1.67-.81-2.47.23-3.65,3.06s-.37,3.61,1.06,4.17,2.54-.38,3.42-2.72C168.29,234.24,168.27,233.24,166.47,232.37Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "165.104px 235.93px"
    },
    id: "el2689pme8377h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnx6wyhs7o5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.47,232.37c-1.67-.81-2.47.23-3.65,3.06s-.37,3.61,1.06,4.17,2.54-.38,3.42-2.72C168.29,234.24,168.27,233.24,166.47,232.37Z",
    style: {
      opacity: 0.1,
      transformOrigin: "165.104px 235.93px"
    },
    className: "animable",
    id: "elmvzi1smd7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.09,189c-5,4.61-9.77,11.16-6.22,26.31a8.25,8.25,0,0,0-2.07,8.55c1.38,4.68,5.87,7.75,10,6.87s6.44-5.39,5.07-10.07c-1-3.5-4.78-6.89-7.87-6.66,0,0-3-6.49-.19-15.66,3.79-12.52,18.37-13.55,24.79-12.54C139.48,182.75,124.67,182.93,118.09,189Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.484px 207.37px"
    },
    id: "el52v1lgons2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,220.47c-1.52-5.19-6.5-8.6-11.12-7.62a7.24,7.24,0,0,0-2,.75c-.51.28-2.09,1.37-2.4,1.57-2.94,2-4.3,6-3.09,10.1,1.52,5.19,6.49,8.6,11.11,7.62a7.33,7.33,0,0,0,2.39-1c.37-.24,1.84-1.22,2.21-1.48C125.7,228.45,127,224.52,125.8,220.47Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "116.498px 222.87px"
    },
    id: "el1eq4umjnmn9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6kurm8o4bjh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.8,220.47c-1.52-5.19-6.5-8.6-11.12-7.62a7.24,7.24,0,0,0-2,.75c-.51.28-2.09,1.37-2.4,1.57-2.94,2-4.3,6-3.09,10.1,1.52,5.19,6.49,8.6,11.11,7.62a7.33,7.33,0,0,0,2.39-1c.37-.24,1.84-1.22,2.21-1.48C125.7,228.45,127,224.52,125.8,220.47Z",
    style: {
      opacity: 0.3,
      transformOrigin: "116.498px 222.87px"
    },
    className: "animable",
    id: "elwsdgxbk3vnh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,221.73c-1.52-5.18-6.5-8.59-11.12-7.61s-7.13,6-5.61,11.15,6.49,8.6,11.11,7.62S125.43,226.92,123.91,221.73Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "115.544px 223.504px"
    },
    id: "elbc08oovnwbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsm8fgq2p99s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.91,221.73c-1.52-5.18-6.5-8.59-11.12-7.61s-7.13,6-5.61,11.15,6.49,8.6,11.11,7.62S125.43,226.92,123.91,221.73Z",
    style: {
      opacity: 0.1,
      transformOrigin: "115.544px 223.504px"
    },
    className: "animable",
    id: "el614hgb1vge6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,222.67c-.72-2.45-3.06-4.06-5.24-3.6s-3.37,2.82-2.65,5.27,3.06,4,5.24,3.59S120.21,225.11,119.49,222.67Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "115.545px 223.494px"
    },
    id: "elves2cgdkf6m",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5",
    className: "animable",
    style: {
      transformOrigin: "188.37px 174.942px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.27,165.06a2.1,2.1,0,0,0-.58.48,2.79,2.79,0,0,0-.38.62,3.81,3.81,0,0,0-.22.7c0,.24-.08.49-.1.74s0,.34,0,.58,0,.49,0,.74,0,.51,0,.75,0,.42,0,.55a3.74,3.74,0,0,0,.1.64,1.21,1.21,0,0,0,.22.44.55.55,0,0,0,.39.18,1,1,0,0,0,.57-.18,2.54,2.54,0,0,0,.5-.38,2.63,2.63,0,0,0,.4-.53,2.85,2.85,0,0,0,.28-.69,3.76,3.76,0,0,0,.1-.86l-.85.49a.15.15,0,0,1-.2,0,.34.34,0,0,1-.08-.25v-1.65a.89.89,0,0,1,.08-.35.51.51,0,0,1,.2-.23l2.45-1.42a.15.15,0,0,1,.19,0,.34.34,0,0,1,.08.25v2a7.81,7.81,0,0,1-.24,1.94,8,8,0,0,1-.67,1.73,6.76,6.76,0,0,1-1,1.43,5.1,5.1,0,0,1-1.24,1,2.69,2.69,0,0,1-1.3.42,1.47,1.47,0,0,1-1-.35,2.13,2.13,0,0,1-.62-1,5.1,5.1,0,0,1-.25-1.49c0-.41,0-.87,0-1.36s0-1,0-1.41a7.84,7.84,0,0,1,.24-1.77,8.33,8.33,0,0,1,.63-1.71,7,7,0,0,1,1-1.48,5.21,5.21,0,0,1,1.31-1.09,2.64,2.64,0,0,1,1.28-.41,1.57,1.57,0,0,1,1,.25,1.82,1.82,0,0,1,.62.72,2.31,2.31,0,0,1,.24,1,.48.48,0,0,1-.06.28.48.48,0,0,1-.16.2l-1.35.77q-.15.09-.24,0l-.16-.18a.81.81,0,0,0-.39-.29C177.85,164.8,177.6,164.87,177.27,165.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "177.261px 168.162px"
    },
    id: "elwa4wps9351o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,167.15a1.28,1.28,0,0,0,.08.54.5.5,0,0,0,.22.25.41.41,0,0,0,.29,0,1,1,0,0,0,.32-.12,2.16,2.16,0,0,0,.48-.37,1.9,1.9,0,0,0,.3-.44,1.86,1.86,0,0,1,.16-.27.41.41,0,0,1,.17-.14l1.32-.76c.15-.09.22,0,.22.21a2.53,2.53,0,0,1-.15.66,6.6,6.6,0,0,1-1.3,2.22,4.63,4.63,0,0,1-1.2,1,2.37,2.37,0,0,1-1.17.39,1.13,1.13,0,0,1-.86-.34,2.14,2.14,0,0,1-.53-1,6.52,6.52,0,0,1-.18-1.66,8.81,8.81,0,0,1,.18-1.78,7.32,7.32,0,0,1,.53-1.64,6.21,6.21,0,0,1,.86-1.37,4.27,4.27,0,0,1,1.17-1,2.05,2.05,0,0,1,1.26-.35,1.32,1.32,0,0,1,.85.5,2.74,2.74,0,0,1,.48,1.09,7.27,7.27,0,0,1,.14,1.42v.44a.68.68,0,0,1-.08.34.48.48,0,0,1-.19.24Zm.91-3.52a1.53,1.53,0,0,0-.65.76,3.06,3.06,0,0,0-.26,1l1.82-1.06a1.37,1.37,0,0,0-.26-.72C184.44,163.47,184.22,163.46,183.94,163.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "183.904px 165.749px"
    },
    id: "elq4267rcxjln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,163.13a.86.86,0,0,0,.11.5c.06.09.18.09.33,0l.81-.47a.15.15,0,0,1,.19,0,.3.3,0,0,1,.08.25V165a.74.74,0,0,1-.08.35.5.5,0,0,1-.19.23l-1,.56a2,2,0,0,1-.87.29.91.91,0,0,1-.66-.23,1.66,1.66,0,0,1-.43-.72,4.08,4.08,0,0,1-.15-1.2v-2.62l-.75.43a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-1.57a.89.89,0,0,1,.08-.35.5.5,0,0,1,.19-.23l.75-.44V156.7a.84.84,0,0,1,.08-.34.61.61,0,0,1,.19-.24l1.28-.73a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25v2.54l1.15-.66a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.25v1.58a.71.71,0,0,1-.08.34.53.53,0,0,1-.19.24l-1.15.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "189.321px 160.892px"
    },
    id: "el7isbhyeozbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.33,153.24a.89.89,0,0,1-.08.35.51.51,0,0,1-.2.23l-1.27.74a.16.16,0,0,1-.2,0,.37.37,0,0,1-.08-.25v-1.58a.84.84,0,0,1,.08-.34.55.55,0,0,1,.2-.24l1.27-.73a.15.15,0,0,1,.2,0,.34.34,0,0,1,.08.25Zm0,9a.89.89,0,0,1-.08.35.51.51,0,0,1-.2.23l-1.27.74a.16.16,0,0,1-.2,0,.37.37,0,0,1-.08-.25V156a.89.89,0,0,1,.08-.35.51.51,0,0,1,.2-.23l1.27-.74a.16.16,0,0,1,.2,0,.37.37,0,0,1,.08.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "195.415px 157.488px"
    },
    id: "elze1leedwmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,158.42a.71.71,0,0,1-.08.34.6.6,0,0,1-.19.24l-1.28.73a.14.14,0,0,1-.19,0,.3.3,0,0,1-.08-.25v-3.95a1.65,1.65,0,0,0-.21-1c-.15-.19-.37-.2-.67,0a1.54,1.54,0,0,0-.67.79,3.21,3.21,0,0,0-.2,1.2v3.94a.76.76,0,0,1-.09.35.45.45,0,0,1-.19.23l-1.27.74a.15.15,0,0,1-.2,0,.34.34,0,0,1-.08-.25v-7.26a.89.89,0,0,1,.08-.35.51.51,0,0,1,.2-.23L199,153c.08,0,.14,0,.19,0a.33.33,0,0,1,.09.25v.36c.05-.13.12-.28.2-.44a4.09,4.09,0,0,1,.29-.48,5.39,5.39,0,0,1,.4-.45,3.16,3.16,0,0,1,.53-.39,2,2,0,0,1,.9-.3.87.87,0,0,1,.69.24,1.89,1.89,0,0,1,.45.85,5.58,5.58,0,0,1,.16,1.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "200.201px 156.682px"
    },
    id: "el5ld1bh7b6ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,187.55a.87.87,0,0,0,.1.5c.07.09.18.09.34,0l.81-.47a.15.15,0,0,1,.19,0,.37.37,0,0,1,.08.25v1.58a.84.84,0,0,1-.08.34.48.48,0,0,1-.19.24l-1,.55a1.69,1.69,0,0,1-.86.29.9.9,0,0,1-.66-.22,1.49,1.49,0,0,1-.43-.72,4.08,4.08,0,0,1-.15-1.2v-2.62l-.75.43c-.08,0-.14,0-.19,0a.33.33,0,0,1-.09-.25v-1.58a.72.72,0,0,1,.09-.34.48.48,0,0,1,.19-.24l.75-.43v-2.54a.74.74,0,0,1,.08-.35.5.5,0,0,1,.19-.23l1.28-.74a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v2.55l1.15-.66a.14.14,0,0,1,.19,0,.36.36,0,0,1,.08.25v1.57a.89.89,0,0,1-.08.35.57.57,0,0,1-.19.23L175,185Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.32px 185.298px"
    },
    id: "elo72tyuybdgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,181.64c0,.15,0,.35,0,.6s0,.44,0,.6a6.89,6.89,0,0,1-.22,1.54,7.35,7.35,0,0,1-.56,1.46,5.91,5.91,0,0,1-.86,1.27,4.43,4.43,0,0,1-1.11.93,2.31,2.31,0,0,1-1.13.36,1.22,1.22,0,0,1-.85-.28,1.87,1.87,0,0,1-.56-.82,4,4,0,0,1-.22-1.28c0-.15,0-.34,0-.59s0-.45,0-.61a6.7,6.7,0,0,1,.21-1.52,7.21,7.21,0,0,1,.56-1.47,6.37,6.37,0,0,1,.86-1.28,4.36,4.36,0,0,1,1.13-.94,2.33,2.33,0,0,1,1.11-.35,1.35,1.35,0,0,1,.87.28,1.85,1.85,0,0,1,.55.82A4,4,0,0,1,182.65,181.64ZM179,184.89a1,1,0,0,0,.28.77c.17.13.38.12.66,0a1.8,1.8,0,0,0,.65-.71,2.74,2.74,0,0,0,.28-1.09c0-.17,0-.35,0-.54s0-.37,0-.52a1,1,0,0,0-.28-.77.56.56,0,0,0-.65,0,1.75,1.75,0,0,0-.66.71,2.74,2.74,0,0,0-.28,1.09c0,.17,0,.35,0,.55S179,184.75,179,184.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "179.895px 183.831px"
    },
    id: "elvs2r0ff9oeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55,178.08a.84.84,0,0,1,.08-.34.49.49,0,0,1,.2-.24l1.27-.74a.15.15,0,0,1,.19,0,.3.3,0,0,1,.09.25V181a1.84,1.84,0,0,0,.19,1c.13.19.34.21.64,0a1.49,1.49,0,0,0,.63-.78A3.52,3.52,0,0,0,187,180v-4a.73.73,0,0,1,.08-.34.6.6,0,0,1,.19-.24l1.28-.73a.14.14,0,0,1,.19,0,.36.36,0,0,1,.08.25v7.27a.84.84,0,0,1-.08.34.48.48,0,0,1-.19.24l-1.18.68a.14.14,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-.35c-.06.14-.12.29-.2.44a3,3,0,0,1-.29.47,4,4,0,0,1-.4.45,3.44,3.44,0,0,1-.54.4c-.65.37-1.18.39-1.56,0a3.27,3.27,0,0,1-.59-2.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "186.155px 179.784px"
    },
    id: "el7mkhn4ebtwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,176.5a4.79,4.79,0,0,0,0,.56,4.19,4.19,0,0,0,0,.53,1,1,0,0,0,.27.75c.16.14.38.12.65,0a1.62,1.62,0,0,0,.51-.45,2.25,2.25,0,0,0,.29-.58,1.39,1.39,0,0,1,.12-.28.48.48,0,0,1,.17-.2L195,176a.15.15,0,0,1,.2,0,.27.27,0,0,1,.07.25,4.58,4.58,0,0,1-.13.81,5.77,5.77,0,0,1-.42,1.2,6.85,6.85,0,0,1-.82,1.3,4.67,4.67,0,0,1-1.32,1.12,2.57,2.57,0,0,1-1.06.36,1.33,1.33,0,0,1-.86-.22,1.75,1.75,0,0,1-.59-.79,4.2,4.2,0,0,1-.24-1.36c0-.15,0-.35,0-.61s0-.47,0-.63a7.37,7.37,0,0,1,.24-1.63,6.84,6.84,0,0,1,.59-1.47,6.06,6.06,0,0,1,.86-1.22,4.71,4.71,0,0,1,1.06-.86,2.35,2.35,0,0,1,1.32-.41,1.38,1.38,0,0,1,.82.36,1.6,1.6,0,0,1,.42.71,2.52,2.52,0,0,1,.13.66.61.61,0,0,1-.07.34.71.71,0,0,1-.2.24l-1.33.76c-.07,0-.13,0-.17,0a.44.44,0,0,1-.12-.15.5.5,0,0,0-.29-.25.75.75,0,0,0-.51.15,1.69,1.69,0,0,0-.65.72A2.68,2.68,0,0,0,191.64,176.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "192.554px 176.443px"
    },
    id: "elv40p67x3t1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,175a.74.74,0,0,1-.08.35.45.45,0,0,1-.19.23l-1.27.74a.16.16,0,0,1-.2,0,.38.38,0,0,1-.08-.26v-3.94a1.6,1.6,0,0,0-.21-1c-.14-.19-.37-.2-.67,0a1.46,1.46,0,0,0-.66.78,3.25,3.25,0,0,0-.21,1.2V177a.88.88,0,0,1-.08.34.61.61,0,0,1-.2.24l-1.27.73a.14.14,0,0,1-.19,0,.32.32,0,0,1-.08-.25V167.86a.74.74,0,0,1,.08-.35.45.45,0,0,1,.19-.23l1.27-.74a.16.16,0,0,1,.2,0,.37.37,0,0,1,.08.25v3.33a4.31,4.31,0,0,1,.54-.95,2.58,2.58,0,0,1,.84-.78,2.07,2.07,0,0,1,.89-.31.91.91,0,0,1,.69.25,1.75,1.75,0,0,1,.45.85,5.55,5.55,0,0,1,.16,1.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.825px 172.426px"
    },
    id: "ellgypyd0qffn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5,169.9a.71.71,0,0,1-.08.34.48.48,0,0,1-.19.24l-1.28.73a.14.14,0,0,1-.19,0,.36.36,0,0,1-.08-.25v-6.72a.81.81,0,0,1,.08-.34.54.54,0,0,1,.19-.24l1.28-.74a.14.14,0,0,1,.19,0,.3.3,0,0,1,.08.25Zm0,3.35a.74.74,0,0,1-.08.35.5.5,0,0,1-.19.23l-1.28.74a.15.15,0,0,1-.19,0,.37.37,0,0,1-.08-.25v-1.58a.81.81,0,0,1,.08-.34.54.54,0,0,1,.19-.24l1.28-.74a.15.15,0,0,1,.19,0,.3.3,0,0,1,.08.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "203.591px 168.743px"
    },
    id: "el18umiz30abw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.19,209.39a1.3,1.3,0,0,1-.92-2.21c1.86-1.9,3-4.57,3.54-8.15-6.26-1.28-10-6.71-10-14.59,0-14,11.37-31.89,25.35-40h0c7.44-4.29,14.53-5.13,19.45-2.29,4.08,2.35,6.32,7.05,6.32,13.22,0,14-11.37,31.88-25.35,40a33.15,33.15,0,0,1-5.82,2.69c-3.34,7.44-8.49,10.25-12.24,11.29A1.06,1.06,0,0,1,170.19,209.39Zm18.41-64.17c-13.74,7.93-24.92,25.53-24.92,39.22,0,7.72,3.53,12.76,9.68,13.83l.4.07,0,.4c-.52,4-1.77,6.93-3.84,9a.46.46,0,0,0,.45.76c3.59-1,8.55-3.72,11.76-11l.08-.17.18-.06a33.18,33.18,0,0,0,5.84-2.68c13.74-7.94,24.92-25.53,24.92-39.22,0-5.86-2.09-10.29-5.89-12.49-4.65-2.68-11.43-1.84-18.61,2.3Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "188.37px 174.942px"
    },
    id: "elbg0bg9yk4yn",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5",
    className: "animable",
    style: {
      transformOrigin: "348.729px 253.168px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5",
    className: "animable",
    style: {
      transformOrigin: "348.729px 253.168px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,396.53a7.81,7.81,0,0,0-.1,4.11c.39.82,2.85,3.54,7.87,4.52s11.93,0,14.9-.18,12.3,1,15.26,1.36c4.66.63,8.25-.39,10-2.08a3.1,3.1,0,0,0,.7-2.45,12.45,12.45,0,0,0-.5-3.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.167px 401.529px"
    },
    id: "el7wis63y7k83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,393.61c.09.39.17.77.25,1.17a19.54,19.54,0,0,1,.43,6.05c-.6,1.47-2.25,2.28-3.58,2.7-3.5,1.12-6.18.94-10.07.2a71.19,71.19,0,0,0-11.81-.72c-3.06.2-7.27.79-10.33.51a24.85,24.85,0,0,1-7.61-1.55c-2-.88-4.13-2-4.62-4.1-.61-4.42,1.25-6.38,3.35-7.61s5.08-1.14,8.27-1.36c2.88-.19,5-.19,7.55-.39a36.67,36.67,0,0,0,6.6-.92c1.93-.61,3.92-3.07,4.74-3.16,0,0,12.84-.1,14.07,0,1.41.12,1.85,4.51,2,5.46.14.75.16,1.55.36,2.27C370.13,392.64,370.25,393.12,370.37,393.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "347.016px 394.357px"
    },
    id: "elgmya4o9payj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.79,402.93c-.4-3.19-.93-10.1,4.94-14.09l.75,0a14.61,14.61,0,0,0-8.12,0c-4.7,1.25-6.78,5.05-5.61,9.06C322.75,397.86,323.8,401.74,330.79,402.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "329.455px 395.597px"
    },
    id: "elombcq83p9mn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.93,387.83c-1.9,1.68-2.56,5.51-2.56,5.51-.24,1.43-2.84,1.64-2.59.26a15,15,0,0,1,2.24-5.33A4.4,4.4,0,0,1,347.93,387.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "345.347px 391.141px"
    },
    id: "elv0k1b1ufmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,388.48a9.25,9.25,0,0,0-2.67,5.22c-.26,1.37-2.43,1.35-2.28,0,0,0,.26-3.39,2.28-5A2.89,2.89,0,0,1,342.61,388.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "340.131px 391.486px"
    },
    id: "el8fpw7mbmfqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26,355.59c-.19,2.25-.49,4.28.43,6.76,1.32,3.57,4.12,5.2,5.76,6.6a47.91,47.91,0,0,1,4.78,5.51c1.61,2,2,3.14,4.46,5.28a8.73,8.73,0,0,0,8.59,1.21c2.1-.89,2.82-1.6,2.69-4.82s-10.37-4.31-10.37-4.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "389.521px 368.581px"
    },
    id: "el8iavi2yuoad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,366.55c.87.31,1.09,1.9,1.23,5,.1,2.39,1.15,5.87-2.3,7.37-2.78,1.22-7.23.41-9.11-1.83-2.35-2.81-3.93-5.27-7.28-8.69-2.91-3-5.93-4-7.22-9.9-.83-3.81-.18-5.39,2.52-6.48,3.7-1.5,9.53,3.41,12.44,4.18C394.43,356.91,400.78,366.23,401.65,366.55Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "389.87px 365.612px"
    },
    id: "elhobjf96d59n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.93,356.24c-.16,0-.33-.1-.5-.16a9.56,9.56,0,0,0-8,5c-.49,1,1,1.85,1.94,1,2.07-3.91,6.33-4.78,8-5A4.35,4.35,0,0,0,391.93,356.24Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "388.352px 359.254px"
    },
    id: "el7lmiuxzga0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.32,358a9.45,9.45,0,0,0-7.46,5c-.49,1,1,1.85,1.94,1a9.73,9.73,0,0,1,6.69-4.75C395.09,358.84,394.7,358.41,394.32,358Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "391.127px 361.174px"
    },
    id: "eluboh9f18aeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,362.93s.29-7.06,10.32-8l.57.31a8.54,8.54,0,0,0-4.93-3.62c-3.33-.86-6,0-7.72,2.11S376.94,361.55,378.67,362.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.882px 357.11px"
    },
    id: "eldw9xkj0cd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,316.62c-1-11-1.07-18.31-1.07-18.31s0-16,.4-31.11c.22-8.4.07-14.1.21-20.74a106,106,0,0,0-1.75-22s-51.46-10.24-52.1,8.64c-.77,22.63-.68,61.31-1.55,76.09-.49,8.3.35,15.17.87,31.29.43,13.36.3,46.26.3,46.26,5.67,7.78,19.05,1.85,19.05,1.85s4.14-46.18,4.74-55.73c.65-10.26-.43-15.46-.43-15.46l5.31-47.81s.4,15.34.86,23.64S381.05,308,383,323.42c2,16.15,5.28,45.41,5.28,45.41,6.86,4.08,14.85.81,14.85.81S406.11,328.28,405.07,316.62Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "377.176px 306.22px"
    },
    id: "el07y7k8y39ac7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrwxm2i84glh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.07,316.62c-1-11-1.07-18.31-1.07-18.31s0-16,.4-31.11c.22-8.4.07-14.1.21-20.74a106,106,0,0,0-1.75-22s-51.46-10.24-52.1,8.64c-.77,22.63-.68,61.31-1.55,76.09-.49,8.3.35,15.17.87,31.29.43,13.36.3,46.26.3,46.26,5.67,7.78,19.05,1.85,19.05,1.85s4.14-46.18,4.74-55.73c.65-10.26-.43-15.46-.43-15.46l5.31-47.81s.4,15.34.86,23.64S381.05,308,383,323.42c2,16.15,5.28,45.41,5.28,45.41,6.86,4.08,14.85.81,14.85.81S406.11,328.28,405.07,316.62Z",
    style: {
      opacity: 0.4,
      transformOrigin: "377.176px 306.22px"
    },
    className: "animable",
    id: "el2ciu45c2v4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsmczx1i6f4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,250.57s-2.1,7.69-14.85,12.85c0,0-3.46,27.84-3.43,27.26l-.68-21.08,1.16-8.84S392.16,258.23,398,250.57Z",
    style: {
      opacity: 0.25,
      transformOrigin: "388.52px 270.629px"
    },
    className: "animable",
    id: "el9d6bycbab3i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.09,156.81c5.14,0,9.77,1.52,13.87,14.29s7.64,29.47,8,33.6c.44,5.36.16,7.67-4,11.56s-15,13.13-15,13.13l-3.6-15.29,8.34-9.4Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "407.736px 193.1px"
    },
    id: "el763xxp1s6ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elif4om1xnc3i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.09,156.81c5.14,0,9.77,1.52,13.87,14.29s7.64,29.47,8,33.6c.44,5.36.16,7.67-4,11.56s-15,13.13-15,13.13l-3.6-15.29,8.34-9.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "407.736px 193.1px"
    },
    className: "animable",
    id: "elrk32h16h3t8"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "371.15 152.21 373.16 170.02 389.72 166.26 387.58 142.47 371.15 152.21",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "380.435px 156.245px"
    },
    id: "elnsgu553rubq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.7,130.39s-4.42,6.71-3.92,7.36,3.76,1.26,3.76,1.26Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "356.72px 134.7px"
    },
    id: "elh12i07dvlbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.66,134.35a5,5,0,1,1,5-5A5,5,0,0,1,360.66,134.35Zm0-8.89a3.89,3.89,0,1,0,3.89,3.89A3.9,3.9,0,0,0,360.66,125.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.66px 129.35px"
    },
    id: "eldcvltok5xqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,112.77c-8.5,1.79-11.55,5.19-12.35,18.69-.84,14.11,1.2,18.88,3.05,20.78,1.25,1.29,8.2,1.52,11.71.55,4.39-1.21,14.31-4.73,19-11.82,5.47-8.35,6.9-19.67,1.05-24.31C385.15,110.12,374.42,112,371,112.77Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "377.843px 132.653px"
    },
    id: "elfelcq0lv1we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,153.19l-.4-2.6a16.83,16.83,0,0,1-8.71,2C363.77,153.36,368,153.59,371.26,153.19Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "366.705px 151.987px"
    },
    id: "el268c0033u6cj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.51 128.44 371.63 130.4 371.02 131.46 356.51 129.58 356.51 128.44",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.07px 129.95px"
    },
    id: "eljkl23ehibmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.75,118.22a4.21,4.21,0,0,0,1.92-.12,3,3,0,0,0,1,3.54,4.27,4.27,0,0,0,3.81.51,3.71,3.71,0,0,0-.42,2.63,4.25,4.25,0,0,0,4.4,3.17c.09,2,.12,3.91,2.23,4.81,0,0,1.34-5.22,5.74-4.56s5,6.3,2.23,9.73-5.35,2.13-5.39,2.11a9.15,9.15,0,0,0,.7,2.49,10.15,10.15,0,0,0,3.72,4.1,20.07,20.07,0,0,0,10.59,2.87c1.38-4,3.65-7,6.05-10.5,1.89-2.74,4.29-5.86,5.24-9.05a17.86,17.86,0,0,0,.11-10.63c-1.05-3.16-2.28-5.56-5.72-6.41-.78-4.23-5-6.46-8.84-8.4a14.22,14.22,0,0,0-12.44-.1c-1.42-1.5-2.54-3.3-4.51-4.17a4.1,4.1,0,0,0-4.82.86,6.1,6.1,0,0,0-.76,4.05,9.49,9.49,0,0,0-4.85.42,5,5,0,0,0-3.12,3.53,3.46,3.46,0,0,0,2.17,3.92,3,3,0,0,0-1.1,3.44A2.59,2.59,0,0,0,357.75,118.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.493px 124.655px"
    },
    id: "elzp0emrns4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,135.73l.15-5.9a3,3,0,1,0-.15,5.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.982px 132.766px"
    },
    id: "eljlw27v40c0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.37,164.91c-1.79-4.57-5.66-8.51-11.93-8.7-1.39,0-4.59,0-4.59,0-.71,2.91-11.75,3.85-17,2-2.29.6-13.41,3.5-15.32,4.14-5.46,1.81-5.53,8.77-5.5,24.93,0,15.06,0,32.94-.82,51.79,9.6,5.06,23.54,6.36,34.1,5.29,16.58-1.67,20.57-6.63,20.57-6.63a237.34,237.34,0,0,1-.6-26.09c.2-7.24,1.73-16.09,2.27-23.92S407.05,169.18,405.37,164.91Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "378.534px 200.459px"
    },
    id: "elpyocsyc14le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4f9o1itvme4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.37,164.91c-1.79-4.57-5.66-8.51-11.93-8.7-1.39,0-4.59,0-4.59,0-.71,2.91-11.75,3.85-17,2-2.29.6-13.41,3.5-15.32,4.14-5.46,1.81-5.53,8.77-5.5,24.93,0,15.06,0,32.94-.82,51.79,9.6,5.06,23.54,6.36,34.1,5.29,16.58-1.67,20.57-6.63,20.57-6.63a237.34,237.34,0,0,1-.6-26.09c.2-7.24,1.73-16.09,2.27-23.92S407.05,169.18,405.37,164.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "378.534px 200.459px"
    },
    className: "animable",
    id: "elzp2qq9sw7sk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.85,141.51c-.93-2.12.13-5.58.53-7.13.66-2.56.27-6.09.43-7.12.39-2.64-1.38-3.17-2.69-1.41-1.19,1.59-1.19,5.07-2.08,5.29s-3.45-6.57-4.79-10.53-1.68-6.49-3.88-6c-1.59.36-1.51,2.41-.73,5.66a34.68,34.68,0,0,1,1,4.27c0,.54-.79.62-1.15.74-.68.24-1.85.6-2.2,1.26a5.91,5.91,0,0,1-.54,1.1c-.58.73-1.77.7-2.39,1.39-.46.5-.5,1.25-.87,1.82-.24.36-.61.63-.84,1a3,3,0,0,0-.07,2.48,20.79,20.79,0,0,0,4.18,7c1.5,1.89,3.86,4.95,4.72,6.3,2.86,4.48,13.41,21.61,18.62,28.35,1.11,1.43,2.1,2.75,4.48,3.39,6,1.6,42.6,4.77,42.6,4.77,10.6.22,14.29-19.1,5.25-20.06,0,0-7.34-.18-16.13-.25-9.4-.09-25.15-.49-25.15-.49S299.59,143.19,298.85,141.51Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "320.944px 149.346px"
    },
    id: "elq9y757f8rus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,162.44c-5.43-.21-41.23.09-41.23.09l-14.9-15.88a14.52,14.52,0,0,1-10.8,8.3s6.48,11.82,10.2,17.25c3.42,5,4.24,7.55,9.54,8.58s38.87,4.88,41.78,4.78,7.68-.61,10.7-9.1C366.92,169,364.5,162.66,359,162.44Z",
    style: {
      fill: "#7C90DB",
      transformOrigin: "328.713px 166.106px"
    },
    id: "el2jzs0hc78cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3phe97iwel1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,162.44c-5.43-.21-41.23.09-41.23.09l-14.9-15.88a14.52,14.52,0,0,1-10.8,8.3s6.48,11.82,10.2,17.25c3.42,5,4.24,7.55,9.54,8.58s38.87,4.88,41.78,4.78,7.68-.61,10.7-9.1C366.92,169,364.5,162.66,359,162.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "328.713px 166.106px"
    },
    className: "animable",
    id: "el6v6jxae86ye"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetintouch2);
export default __webpack_public_path__ + "static/media/getintouch2.df2fdb3b71439b24b3b29c0e7c0b9c1b.svg";
export { ForwardRef as ReactComponent };